import React, { useState, useEffect, useRef } from "react";
import { callApi } from "../../../../redux/action/action";
import DatePicker from "react-datepicker";
import $ from "jquery";
import place from "../../../assets/images/place.svg";
import jobTitle from "../../../assets/images/jobTitle.svg";
import "react-datepicker/dist/react-datepicker.css";
import "../components/jobType.css";
import { axiosInstance } from "../../../../config/axiosConfig";
import { stateOfUs } from "../../../../constants/otherConstans";
import calendar from "../../../assets/images/calendar.png";
import edit_note from "../../../assets/images/edit_note.svg";
import { useDispatch, useSelector } from "react-redux";
import edit_badge from "../../../assets/images/edit_badge.svg";
import key from "../../../assets/images/key.svg";
import useLoader from "../../../modals/hooks/useLoader";
import Loader from "../../../modals/Loader";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import VisibilityIcon from "@material-ui/icons/Visibility";
import trans from "../../../assets/images/trans.svg";
import setting from "../../../assets/images/settings.png";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import moment from "moment";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../common/toastMeassage/ToastMeassage";
import Modal from "../../../common/modal";
import Button from "../../../ui/Button";
import classNames from "classnames";
import ContactDetails from "../contactDetails";
import iIcon from "../../../assets/images/iIcon.svg";
import CustomSelect from "../../../ui/CustomSelect";
import ErrorState from "../../../theme_1/staffSignUp/components/errorState";
import Tooltip from "../../../ui/Tooltip";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

const JobType = ({ adminStaffId }) => {
  const isAdmin = useSelector((state) => state?.staffProfile?.admin);
  const profile = useSelector((state) => state.data.profile);
  const [dobDate, setDobDate] = useState(null);
  const dispatch = useDispatch();
  const [weekendAvailability, setWeekendAvailability1] = useState(false);
  const [immediatelyStart, setImmediatelyStart] = useState(false);
  const [id, setId] = useState(false);
  const [startWorkdate, setStartWorkdate] = useState(new Date());
  const [tempPos, setTempPos1] = useState(false);
  const [userData, setUserData] = useState("");
  const [licenseFormData, setLicenseFormData] = useState({});
  const [certificationFormData, setCertificationFormData] = useState({});
  const [nursingStateVal, setNursingStateVal] = useState("");
  const [insuranceOpens, setinsuranceOpens] = useState(false);
  const [drugOpens, setdrugOpens] = useState(false);
  const [nursdelaOpens, setnursdelaOpens] = useState(false);
  const [ssnOpens, setssnOpens] = useState(false);
  const [highOpens, sethighOpens] = useState(false);
  const [highaddOpens, sethighaddOpens] = useState(false);
  const [contactModel, setContactModel] = useState(false);
  const [mappingIndexes, setMappingIndexes] = useState({
    certificationIndex: 0,
    licenseIndex: 0,
  });
  const [certOpens, setcertOpens] = useState(false);
  const [zipChanged, setZipChanged] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [locationModalOpen, setLocationModalOpen] = useState(false);
  const [newLocation, setNewLocation] = useState({
    city: "",
    state: "",
    zipCode: "",
  });
  const [errors, setErrors] = useState({ zipError: "", phoneError: "" });
  const [state, setState] = useState({
    image: "",
    medicalSettings: "",
    resume: {
      lastUpdated: null,
      link: "",
    },
    currentLocation: {
      name: "",
      state: "",
      zipCode: "",
    },
    education: { degree: "", college: "", receivedOn: "" },
    certifications: [
      { name: "", certifyingAuthority: "", receivedOn: "", expirationDate: "" },
    ],
    nursingLicense: {
      name: "",
      number: "",
      expirationDate: "",
    },
    socialSecurityNumber: "",
    name: "",
    phone: "",
  });
  const [testDate, setTestDate] = useState(null);
  const [exp, setExp] = useState("");
  const [nursdOpen, setdIsOpen] = useState(false);
  const [addLicense, setAddLicense] = useState({
    expirationDate: "",
    name: "",
    state: "",
    image: "",
    number: "",
  });
  const [addCertificate, setAddCertificate] = useState({
    name: "",
    certifyingAuthority: "",
    receivedOn: "",
    expirationDate: "",
  });
  const [zipCode, setZipCode] = useState("");
  const [optionstateOpens, setoptionstateOpens] = useState(false);
  const [showOtherExp, setShowOtherExp] = useState(false);
  const { showLoader, hideLoader } = useLoader();
  const [showPassword, setShowPassword] = useState(false);
  const [accordionItemStates, setAccordionItemStates] = useState(
    Array(userData?.nursingLicense?.length).fill(false)
  );

  const nursdAccordion = () => {
    setdIsOpen(!nursdOpen);
  };

  const deletedata = () => {};
  const [error, setError] = useState({
    medical: "none",
    nursingLicence: "none",
    licenseData: "none",
    street: "block",
    zipCode: "block",
  });
  const [_exps, setExps] = useState([
    "Acute Care Hospitals",
    "Urgent Care Centers",
    "Rehabilitation Centers",
    "Nursing Homes",
    "Other Long-term Care Facilities",
    "Specialized Outpatient Services",
    "Specialized Outpatient Surgery Center",
  ]);
  const [selectedExp, setSelectedExp] = useState("");
  const [selectedExpChanged, setSelectedExpChanged] = useState(false);
  const [otherExpText, setOtherExpText] = useState("");
  const [DropdownOpen, setDropdownOpen] = useState(false);
  const [selected, setSelected] = useState("");
  const [professionalOption, setProfessionalOption] = useState([]);
  const [functionalOption, setFunctionalOption] = useState([]);
  const [specializationOption, setSpecializationOption] = useState([]);
  const [selectedFunctionalArea, setSelectedFunctionalArea] = useState("");
  const [selectedSpecialization, setSelectedSpecialization] = useState("");
  const [selectedProfessionalStatus, setSelectedProfessionalStatus] =
    useState("");
  const [otherfunctionalValue, setOtherFunctionalValue] = useState("");
  const [functionalAreaOpen, setFunctionalAreaOpen] = useState(false);
  const [specializationOpen, setSpecializationOpen] = useState(false);
  const [professionalOpen, setProfessionalOpen] = useState(false);
  const [functionalAreaVal, setFunctionalAreaVal] = useState(
    userData?.FunctionalArea || ""
  );
  const [specializationVal, setSpecializationVal] = useState(
    userData?.Specialization || ""
  );
  const [showOtherProfessional, setShowOtherProfessional] = useState(false);
  const [showfunctionalOther, setShowfunctionalOther] = useState(false);

  const [customProfessionalStatus, setCustomProfessionalStatus] = useState("");
  const [isLocationEdit, setLocationEdit] = useState(false);
  const toggleExp = (selectedExp) => {
    setExp(selectedExp);
    setState((prev) => ({ ...prev, medicalSettings: selectedExp }));
    setSelectedExpChanged(true);
    setShowOtherExp(selectedExp === "Other" ? !showOtherExp : showOtherExp);
  };

  const toggleExps = () => {
    setExp("");
    setState((prev) => ({ ...prev, medicalSettings: "" }));
    setShowOtherExp((prev) => !prev);
  };

  const setOtherExp = (e) => {
    const errorCopy = { ...error };
    errorCopy.medical = "none";
    if (e.target.value.length < 51) {
      setExp(e.target.value);
      setState((prev) => ({ ...prev, medicalSettings: e.target.value }));
      if (e.target.value.length > 0) setError(errorCopy);
    }
  };

  useEffect(() => {
    if (selectedExpChanged) {
      setUpdateAllData();
      setSelectedExpChanged(false);
    }
  }, [selectedExpChanged]);

  const continueToNext = () => {
    if (!state?.medicalSettings) {
      showErrorToast("Please enter medical settings.");
      return;
    }
    setSelectedExpChanged(true);
  };
  const setPhone = (e) => {
    const inputValue = e.target.value;

    // Only allow digits and limit to 10 characters
    const numericValue = inputValue.replace(/\D/g, "").slice(0, 10);

    setState((prevState) => ({
      ...prevState,
      phone: numericValue,
    }));

    // Validate phone number (exactly 10 digits)
    const isValid = numericValue.length === 10;

    setErrors((prevState) => ({
      ...prevState,
      phoneError: isValid ? "" : "Please enter a valid 10-digit phone number",
    }));
  };
  const [temporaryPositionsClicked, setTemporaryPositionsClicked] =
    useState(false);

  const certopenModal = () => {
    setcertOpens(true);
  };
  const certcloseModal = () => {
    setcertOpens(false);
  };
  const highopenModal = () => {
    sethighOpens(true);
  };
  const highcloseModal = () => {
    sethighOpens(false);
  };
  const highaddopenModal = () => {
    sethighaddOpens(true);
  };
  const highaddcloseModal = () => {
    setAddCertificate({});
    sethighaddOpens(false);
  };
  const ssnopenModal = () => {
    setssnOpens(true);
  };
  const ssncloseModal = () => {
    setssnOpens(false);
  };
  const insuropenModal = () => {
    setinsuranceOpens(true);
  };
  const insurcloseModal = () => {
    setinsuranceOpens(false);
  };

  const drugopenModal = () => {
    setdrugOpens(true);
  };
  const drugcloseModal = () => {
    setdrugOpens(false);
  };
  const nursdelaopenModal = () => {
    setnursdelaOpens(true);
  };

  const optionstateopenModal = (val) => {
    setNursingStateVal(val);
    setoptionstateOpens(true);
    setDropdownOpen(false);
  };
  // const optionstateopenModal = (val) => {
  //   setNursingStateVal(val.target?.value);
  //   setoptionstateOpens(true);
  // };
  const optionstatecloseModal = () => {
    setoptionstateOpens(false);
    setNursingStateVal("");
  };
  function getDob() {
    const dob = userData?.dob;
    if (!dob || dob.day == null || dob.month == null || dob.year == null) {
      return ""; // or return 'Loading...' or 'N/A'
    }

    const day = String(dob.day).padStart(2, "0");
    const month = String(dob.month).padStart(2, "0");
    const year = dob.year;

    return `${month}-${day}-${year}`;
  }

  const usertype = localStorage.getItem("type");
  async function fetchData(id) {
    try {
      showLoader();
      var res = await axiosInstance.get(`v1/LHS/staff/getById/${id}`);
      const allData = res.data.data;
      if (allData) {
        const {
          image,
          medicalSettings,
          resume,
          currentLocation,
          education,
          certifications,
          nursingLicense,
          socialSecurityNumber,
          currentProfessionalStatus,
          FunctionalArea,
          Specialization,
        } = allData || {};
        setUserData(allData);
        setState({
          image,
          medicalSettings,
          resume,
          currentLocation,
          education,
          certifications,
          nursingLicense,
          socialSecurityNumber,
        });

        setSelected(currentProfessionalStatus);
        setSelectedFunctionalArea(FunctionalArea);

        if (_exps.includes(medicalSettings)) {
          setExp(medicalSettings);
        } else {
          setExp(medicalSettings);
          setShowOtherExp(true);
        }
        setZipCode(allData?.currentLocation?.zipCode);
      }
    } catch (err) {
      console.log(err);
    } finally {
      hideLoader();
    }
  }
  const fetchCityStateFromZip = async () => {
    try {
      const res = await axiosInstance.post("v1/LHS/other/getCityState", {
        zip: newLocation.zipCode,
      });
      const data = res?.data?.data;
      if (data?.length > 0) {
        setNewLocation((prev) => ({
          ...prev,
          city: data[0].city,
          state: data[0].state,
        }));
      } else {
        showErrorToast("Invalid ZIP Code");
      }
    } catch (err) {
      console.error("Error fetching city/state:", err);
      showErrorToast("Failed to fetch location");
    }
  };

  const fetchProfessionalStatuses = async () => {
    try {
      const res = await callApi("GET", "v2/LHS/User/professional-status");

      if (res?.data) {
        setProfessionalOption(
          (res.data || []).map((item) => ({
            label: item.name,
            value: item._id,
          }))
        );
      }
    } catch (err) {
      console.error("Error fetching professional statuses:", err);
    }
  };
  const fetchFunctionalAreas = async () => {
    try {
      const res = await axiosInstance.get("v2/LHS/User/functional-areas");

      if (res?.data) {
        const functionalAreas = res.data.data || [];

        // Set options for dropdown
        setFunctionalOption(
          functionalAreas.map((item) => ({
            label: item.name,
            value: item._id,
          }))
        );

        // If user has a functional area, find its ID and fetch specializations
        if (userData.FunctionalArea) {
          const matchedArea = functionalAreas.find(
            (area) => area.name === userData.FunctionalArea
          );

          if (matchedArea) {
            setSelectedFunctionalArea(matchedArea._id);
            fetchSpecializations(matchedArea._id); // Fetch specializations for this ID
          } else {
            // Handle case where functional area is not in the list (e.g., "Other")
            setShowfunctionalOther(true);
            setSelectedFunctionalArea("Other");
          }
        }
      }
    } catch (err) {
      console.error("Error fetching functional areas:", err);
    }
  };
  const fetchSpecializations = async (functionalAreaId) => {
    try {
      const res = await callApi(
        "GET",
        `v2/LHS/User/specializations/${functionalAreaId}`
      );

      if (res?.data) {
        setSpecializationOption(
          (res.data || []).map((item) => ({
            label: item.name,
            value: item._id,
          }))
        );
        // If user has a specialization, find and set its ID
        // if (userData?.Specialization) {
        //   const selectedSpecialization = res.data.data.find(
        //     (item) => item.name === userData.Specialization
        //   );
        //   if (selectedSpecialization) {
        //     setSelectedSpecialization(selectedSpecialization._id);
        //   }
        // }
      }
    } catch (err) {
      console.error("Error fetching specializations:", err);
    }
  };
  const handleFunctionalAreaChange = (val) => {
    setSelectedFunctionalArea(val);

    if (val === "Other") {
      setShowfunctionalOther(true);
      setShowOtherProfessional(true);
      setSelectedSpecialization(val);
    } else {
      setShowfunctionalOther(false);

      // Find the selected functional area object

      const selectedArea = functionalOption.find((item) => {
        console.log("Checking item:", item.label, "against value:", val);
        return item.label === val;
      });

      if (selectedArea) {
        fetchSpecializations(selectedArea.value);
      }
    }
  };
  const preventNumberInput = (e) => {
    const charCode = e.which ? e.which : e.keyCode;
    if (charCode >= 48 && charCode <= 57) {
      e.preventDefault();
    }
  };
  useEffect(() => {
    const idToFetch = adminStaffId || profile?._id;
    setId(idToFetch);
    fetchData(idToFetch);
  }, [adminStaffId, profile?._id]);

  useEffect(() => {
    fetchProfessionalStatuses();
    fetchFunctionalAreas();
  }, [userData]);
  //   useEffect(() => {
  //   if (userData?.FunctionalArea && functionalOption.length > 0) {
  //     // Find the functional area object that matches the user's FunctionalArea value
  //     const selectedFunctionalAreaObj = functionalOption.find(
  //       item => item.name === userData.FunctionalArea
  //     );

  //     if (selectedFunctionalAreaObj) {
  //       setSelectedFunctionalArea(selectedFunctionalAreaObj._id);
  //       // Fetch specializations for this functional area
  //       fetchSpecializations(selectedFunctionalAreaObj._id);
  //     } else {
  //       // Handle case where functional area is "Other"
  //       setShowfunctionalOther(true);
  //       setOtherFunctionalValue(userData.FunctionalArea);
  //     }
  //   }
  // }, [userData?.FunctionalArea, functionalOption]);
  useEffect(() => {
    const selectedArea = functionalOption.find((item) => {
      console.log("Checking item:", item.label, "against value:", userData);

      return item.label === userData.FunctionalArea;
    });

    if (selectedArea) {
      fetchSpecializations(selectedArea.value);
    }
  }, [functionalOption, userData.FunctionalArea]);
  const handleDateChange = (date, e) => {
    setTestDate(date);
    handleLicenseChange("expirationDate", date);
  };
  const [editedLicense, setEditedLicense] = useState({
    name: "",
    number: "",
    expirationDate: "",
  });

  const handleEditjob = async () => {
    showLoader();
    try {
      const payload = {
        nursingLicense: {
          name: editedLicense.name,
          number: editedLicense.number,
          expirationDate: editedLicense.expirationDate,
        },
      };

      const response = await axiosInstance.put(
        // `v1/LHS/job/update/${parsedData?._id}`,
        `v1/LHS/staff/update/${id}`,
        payload
      );
      // nursdelacloseModal();
      if (response.status == 200) {
        dispatch({ type: "PROFILE_DATA", payload: response.data.data });
        showSuccessToast("Job Updated Successfully");
        setnursdelaOpens(false);
      } else {
        console.log("Job update unsuccessful");
      }
    } catch (error) {
      // setShowLoader(false);
      console.error("Error updating job:", error);
    } finally {
      hideLoader();
      // setShowLoader(false);
    }
  };

  const handleLicenseChange = (field, value) => {
    setEditedLicense((prevLicense) => ({
      ...prevLicense,
      [field]: value,
    }));
  };

  useEffect(() => {
    if (zipChanged) {
      setZipChanged(false);
      setUpdateAllData();
    }
  }, [zipChanged]);

  const setUpdateNursingLicense = async (allData) => {
    const { name, number, expirationDate, image } = allData || {};
    if (!name || !number || !expirationDate || !image) {
      showErrorToast("All fields are required");
      return;
    }
    try {
      showLoader();
      let updatedImage = "";
      if (allData?.image) {
        try {
          const formData = new FormData();
          formData.append("files", allData?.image);
          let url = "v2/LHS/Upload/uploadFiles";
          const response = await axiosInstance.post(url, formData);
          updatedImage = response.data.data[0];
        } catch (err) {}
      }
      const postData = {
        ...allData,
        image: updatedImage,
        state: nursingStateVal,
      };
      const finalData = {
        nursingLicense: [...state?.nursingLicense, postData],
      };
      var res = await axiosInstance.put(`v1/LHS/staff/update/${id}`, {
        ...finalData,
      });
      if (res.data) {
        fetchData(id);
        showSuccessToast(res?.data?.Message);
      }
      optionstatecloseModal();
      setNursingStateVal("");
      setAddLicense({});
    } catch (err) {
    } finally {
      hideLoader();
    }
  };

  const deleteDetails = async ({ name, index }) => {
    try {
      showLoader();
      let postData = "";
      if (name == "nursinglic") {
        const updatedData = [...state?.nursingLicense];

        updatedData.splice(index, 1);
        postData = { nursingLicense: updatedData };
      }
      if (name == "certifications") {
        const updatedData = [...state?.certifications];

        updatedData.splice(index, 1);
        postData = { certifications: updatedData };
      }
      if (name == "education") {
        postData = { education: { degree: "", college: "", receivedOn: "" } };
      }
      var res = await axiosInstance.put(`v1/LHS/staff/update/${id}`, {
        ...postData,
      });
      if (res.data) {
        fetchData(id);
        showSuccessToast(res?.data?.Message);
      }
    } catch (err) {
    } finally {
      hideLoader();
    }
  };

  const setUpdateAllData = async (allData) => {
    try {
      showLoader();

      const postData = {
        ...state,

        ...(allData || {}),
      };

      const res = await axiosInstance.put(
        `v1/LHS/staff/update/${id}`,
        postData
      );

      if (res.data) {
        fetchData(id);
        showSuccessToast(res?.data?.Message);
      }

      certcloseModal();
    } catch (err) {
      console.error("Error updating profile:", err);
    } finally {
      hideLoader();
      highcloseModal();
      setnursdelaOpens(false);
      ssncloseModal();
      highaddcloseModal();
      setAddCertificate({});
      setCertificationFormData({});
      setNursingStateVal("");
    }
  };

  const handleZipChange = async (e) => {
    const zip = e.target.value;

    // Only allow digits
    const numericZip = zip.replace(/\D/g, "");

    setNewLocation((prev) => ({
      ...prev,
      zipCode: numericZip,
      city: "",
      state: "",
    }));

    if (numericZip.length === 5) {
      setErrors((prev) => ({
        ...prev,
        zipError: "",
      }));
      try {
        const result = await callApi(
          "POST",
          "v1/LHS/other/getCityState",
          null,
          {
            zip: numericZip,
          }
        );

        if (result && result.data && result.data.city && result.data.state) {
          setNewLocation((prev) => ({
            ...prev,
            city: result?.data?.city,
            state: result?.data?.state,
          }));
        } else {
          setErrors((prev) => ({
            ...prev,
            zipError: "please enter valid zip code",
          }));
        }
      } catch (err) {
        console.error("Failed to fetch ZIP location:", err);
      }
    } else {
      setErrors((prev) => ({
        ...prev,
        zipError: "please enter valid zip code",
      }));
    }
  };

  const setStartDate = async (param) => {
    try {
      showLoader();
      var data;
      if (param) {
        data = {
          startWorkDate: new Date(startWorkdate).toISOString(),
          immediatelyStart: true,
        };
      } else {
        data = {
          startWorkDate: new Date().toISOString(),
          immediatelyStart: false,
        };
      }
      var res = await axiosInstance.put(`v1/LHS/staff/update/${id}`, data);
      if (res.data) {
        // setStartWorkdate(res.data)
        setStartWorkdate(new Date(res.data.startWorkDate));
        dispatch({ type: "PROFILE_DATA", payload: res.data.data });
        fetchData(id);
        alert("Start Date is updated");
      }
    } catch (err) {
    } finally {
      hideLoader();
    }
  };
  const setTempPos = async (data) => {
    if (tempPos) {
      try {
        showLoader();
        setTemporaryPositionsClicked(true);
        var data = {
          natureOfJob: data,
        };
        var res = await axiosInstance.put(`v1/LHS/staff/update/${id}`, data);
        if (res.data) {
          dispatch({ type: "PROFILE_DATA", payload: res.data.data });
          fetchData(id);
        }
      } catch (err) {
      } finally {
        hideLoader();
      }
    } else {
      try {
        showLoader();
        setTemporaryPositionsClicked(true);
        var newNatureOfJob = ["Temporary Position"];
        var data = {
          natureOfJob: newNatureOfJob,
        };
        var res = await axiosInstance.put(`v1/LHS/staff/update/${id}`, data);
        if (res.data) {
          dispatch({ type: "PROFILE_DATA", payload: res.data.data });
          fetchData(id);
        }
      } catch (err) {
      } finally {
        hideLoader();
      }
    }
  };
  // const handleStateSelect = (e) => {
  //   const selectedState = e.target.value;
  //   setStateVal(selectedState);
  // };

  const saveLicenseData = async () => {
    const { name, number, expirationDate, image } = licenseFormData || {};
    if (!name || !number || !expirationDate || !image) {
      showErrorToast("All fields are required");
      return;
    }

    let processedImage = image;
    if (image?.name) {
      try {
        const formData = new FormData();
        formData.append("files", image);
        let url = "v2/LHS/Upload/uploadFiles";
        const response = await axiosInstance.post(url, formData);
        processedImage = response.data.data[0];
      } catch (err) {
        // Handle error if needed
      }
    }

    const updatedNursingLicense = state?.nursingLicense;

    const updatedItem = {
      name,
      number,
      expirationDate,
      image: processedImage,
      state: state?.nursingLicense[mappingIndexes?.licenseIndex]?.state,
    };
    updatedNursingLicense[mappingIndexes?.licenseIndex] = updatedItem;
    setUpdateAllData({ nursingLicense: updatedNursingLicense });
    setLicenseFormData({});
  };

  const updateCertificate = async () => {
    const { name, certifyingAuthority, expirationDate, receivedOn } =
      certificationFormData || {};
    if (!name || !certifyingAuthority || !expirationDate || !receivedOn) {
      showErrorToast("All fields are required");
      return;
    }
    const updatedData = state?.certifications;
    updatedData[mappingIndexes?.certificationIndex] = certificationFormData;
    setUpdateAllData({ certifications: updatedData });
  };

  const handleUploadProfile = async (files) => {
    var formData = new FormData();
    formData.append("file", files);
    if (!files?.name) return;
    try {
      let url = "v2/LHS/Upload/uploadFile";
      const response = await axiosInstance.post(url, formData);
      const respData = response.data.data;
      setUpdateAllData({ image: respData });
    } catch {
      console.error("Failed to upload image:");
    }
  };
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <div className="t2_sp_work p-0">
      <div className="flex text-center justify-center flex-col mt-4 gap-1">
        <div className="flex justify-center relative">
          <div className="w-40 h-40 rounded-full overflow-hidden">
            <img src={state?.image} className="object-cover w-full h-full" />
          </div>
          {profile?.role == "staff" && (
            <div className="absolute bottom-0 right-[45%]">
              <img
                src={edit_badge}
                alt="profile"
                className="w-[32px] h-[32px]"
              />
              <input
                type="file"
                accept="image/*"
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    handleUploadProfile(file);
                  }
                }}
                className="w-[100px] absolute left-0 top-0 opacity-0"
              />
            </div>
          )}
        </div>

        <div className="text-[#000] text-2xl">{userData.name}</div>
        <div className="text-[#5c5959] text-xl">
          {userData?.currentLocation?.name &&
          userData?.currentLocation?.state &&
          userData?.currentLocation?.zipCode ? (
            <>
              {userData?.currentLocation?.name},{" "}
              {userData?.currentLocation?.state} |{" "}
              {userData?.currentLocation?.zipCode}
            </>
          ) : null}
        </div>
      </div>

      {/* <div className="border-b-2 border-b-gray-200 my-4"></div> */}

      {/* <div className="px-[30px]">
        <div className="t2_sp_work_title">Nature of job</div>
        {usertype == "staff" && (
          <div
            className="row t2_sp_work_container"
            style={{ border: "none", boxShadow: "none" }}
          >
            {isAdmin ? (
              <button
                className={`t2_sp_work_item ${
                  userData && userData?.natureOfJob[1] == "Temporary Position"
                    ? "t2_sp_item_selected text-[16px]"
                    : "text-[16px]"
                }`}
                onClick={() => setTempPos("Temporary Position")}
                style={{ cursor: isAdmin ? "text" : "pointer" }}
              >
                Temporary Positions
              </button>
            ) : (
              <button
                className={`col-3 t2_sp_work_item ${
                  userData && userData?.natureOfJob[1] == "Temporary Position"
                    ? "t2_sp_item_selected text-[16px]"
                    : "text-[16px]"
                }`}
                onClick={() => setTempPos("Temporary Position")}
                style={{
                  cursor: isAdmin ? "text" : "pointer",
                  height: isAdmin ? "auto" : "55px",
                  width: isAdmin ? "auto" : "220px",
                }}
              >
                Temporary Positions
              </button>
            )}

            <button
              className={`col-3 t2_sp_work_item ${
                userData && userData?.natureOfJob[0] === "Permanent Position"
                  ? "t2_sp_item_selected"
                  : ""
              }`}
              onClick={() => setTempPos("Permanent Position")}
              style={{
                cursor: isAdmin ? "text" : "pointer",
                height: isAdmin ? "auto" : "55px",
                width: isAdmin ? "auto" : "220px",
                backgroundColor: temporaryPositionsClicked
                  ? "t2_sp_item_selected text-[16px]"
                  : "text-[16px]",
              }}
            >
              Parmanent Positions
            </button>
          </div>
        )}
      </div> */}

      {/* <div className="border-b-2 border-b-gray-200 my-4"></div> */}

      {/* <div className="px-[30px]">
        <div
          className="t2_sp_work_title"
          style={{
            marginTop: 48,
          }}
        >
          Work schedule
        </div>
        {usertype == "staff" && (
          <div
            className="row t2_sp_work_container gap-3"
            style={{ border: "none", boxShadow: "none" }}
          >
            <button
              className={
                userData && userData?.workSchedule[0] == "Full Time"
                  ? "col-3 t2_sp_work_item t2_sp_item_selected"
                  : "col-3 t2_sp_work_item"
              }
              onClick={() => setWorkSchedule("Full Time")}
              style={{
                lineHeight: "18px",
                cursor: "pointer",
                fontSize: "16px",
                height: "62px",
              }}
            >
              Full Time <br />{" "}
              <b style={{ fontSize: "16px", fontWeight: "normal" }}>
                (8hrs or more per day)
              </b>
            </button>

            <button
              className={
                userData && userData?.workSchedule[0] == "Part Time"
                  ? "col-3 t2_sp_item_selected t2_sp_work_item"
                  : "col-3 t2_sp_work_item"
              }
              onClick={() => setWorkSchedule("Part Time")}
              style={{
                lineHeight: "18px",
                cursor: "pointer",
                fontSize: "16px",
                height: "62px",
              }}
            >
              Part Time <br />{" "}
              <b style={{ fontSize: "16px", fontWeight: "normal" }}>
                (7hrs or less per day)
              </b>
            </button>
          </div>
        )}
      </div> */}

      {/* <div className="border-b-2 border-b-gray-200 my-4"></div> */}

      {/* <div className="px-[30px]">
        {usertype == "staff" && (
          <div className="t2_sp_work_title" style={{ marginTop: 48 }}>
            Weekend availability
          </div>
        )}
        {usertype == "staff" && (
          <div
            className="row t2_sp_work_container gap-3"
            style={{ border: "none", boxShadow: "none" }}
          >
            <button
              className={
                !weekendAvailability
                  ? "t2_sp_work_item t2_sp_item_selected"
                  : "t2_sp_work_item"
              }
              style={{ width: 170, cursor: "text" }}
            >
              Yes
            </button>
            <button
              className={
                weekendAvailability
                  ? "t2_sp_work_item t2_sp_item_selected"
                  : "t2_sp_work_item"
              }
              style={{ width: 170, cursor: "text" }}
              onClick={setWeekendAvailability}
            >
              No
            </button>
          </div>
        )}
      </div> */}

      {/* <div className="border-b-2 border-b-gray-200 my-4"></div> */}
      {/* <div className="px-[30px]">
        {usertype == "staff" && (
          <div className="t2_sp_work_title" style={{ marginTop: 48 }}>
            Available to start work
          </div>
        )}
        {usertype == "staff" && (
          <div
            className="row t2_sp_work_container gap-3"
            style={{ border: "none", boxShadow: "none" }}
          >
            <button
              className={
                immediatelyStart
                  ? "t2_sp_work_item t2_sp_item_selected w-[200px]"
                  : "t2_sp_work_item w-[200px]"
              }
              style={{ cursor: "pointer", fontSize: "16px" }}
              onClick={() => setStartDate()}
            >
              Immediately
            </button>
            <div
              className={
                immediatelyStart
                  ? "d-flex ssu_datePickerBox ssu2_modal3_selectBox"
                  : "d-flex ssu_datePickerBox ssu2_modal3_selectBox t2_sp_item_selected"
              }
              style={{
                margin: "0px 0px 0px 0px",
                maxWidth: 200,
                borderRadius: "30px",
                fontSize: "16px",
                padding: "0px 25px",
              }}
            >
              <DatePicker
                selected={startWorkdate}
                // onChange={(date) => setStartDate(date)}
                onChange={(date) => setStartWorkdate(date)}
                className="jobtypedate"
                type="number"
              />
              <div
                className={
                  immediatelyStart
                    ? "t2_sp_calendar"
                    : "t2_sp_calendar t2_sp_calendar_selected"
                }
                onClick={() => $(".ssu_datePicker").focus()}
              >
                <svg
                  width="36"
                  height="18"
                  viewBox="0 0 61 30"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M60.2574 4.17908H55.8318C55.7431 4.17908 55.6581 4.21429 55.5955 4.27697C55.5328 4.33964 55.4976 4.42465 55.4976 4.51329C55.4976 4.57024 55.5155 4.62119 55.5403 4.66765V7.21392C55.5404 7.30724 55.5221 7.39966 55.4864 7.48589C55.4507 7.57212 55.3984 7.65047 55.3324 7.71646C55.2664 7.78244 55.1881 7.83476 55.1019 7.87043C55.0156 7.90609 54.9232 7.9244 54.8299 7.9243H53.4526C53.366 7.9243 53.2803 7.90724 53.2003 7.8741C53.1202 7.84097 53.0476 7.79239 52.9863 7.73116C52.9251 7.66993 52.8765 7.59723 52.8434 7.51723C52.8102 7.43722 52.7932 7.35147 52.7932 7.26488V4.70886C52.8374 4.65311 52.8621 4.58442 52.8636 4.51329C52.8637 4.46937 52.8551 4.42587 52.8384 4.38527C52.8216 4.34468 52.797 4.3078 52.766 4.27674C52.7349 4.24569 52.698 4.22108 52.6574 4.20432C52.6168 4.18756 52.5733 4.17898 52.5294 4.17908H43.6085C43.5198 4.17908 43.4348 4.21429 43.3721 4.27697C43.3095 4.33964 43.2743 4.42465 43.2743 4.51329C43.2743 4.56499 43.2885 4.6122 43.3095 4.65641V7.23191C43.3095 7.32293 43.2916 7.41307 43.2567 7.49716C43.2219 7.58126 43.1708 7.65767 43.1065 7.72203C43.0421 7.7864 42.9657 7.83745 42.8816 7.87229C42.7975 7.90712 42.7074 7.92505 42.6163 7.92505H41.3934C41.2078 7.92505 41.0298 7.85131 40.8985 7.72006C40.7673 7.5888 40.6935 7.41078 40.6935 7.22516V4.67514C40.7233 4.62631 40.7396 4.57046 40.7407 4.51329C40.7408 4.46937 40.7322 4.42587 40.7155 4.38527C40.6987 4.34468 40.6741 4.3078 40.6431 4.27674C40.612 4.24569 40.5751 4.22108 40.5345 4.20432C40.4939 4.18756 40.4504 4.17898 40.4065 4.17908H35.7433C35.5464 4.17928 35.3575 4.25755 35.2182 4.39675C35.0789 4.53595 35.0004 4.72472 35 4.92168V27.0528C35 27.4635 35.3335 27.7969 35.7433 27.7969H60.2574C60.4545 27.7965 60.6434 27.7179 60.7826 27.5784C60.9218 27.4389 61 27.2499 61 27.0528V4.92168C60.9996 4.72485 60.9212 4.5362 60.7821 4.39702C60.6429 4.25784 60.4542 4.17947 60.2574 4.17908ZM60.2574 27.1285H35.7433C35.7334 27.1285 35.7236 27.1265 35.7145 27.1227C35.7054 27.1189 35.6971 27.1133 35.6901 27.1063C35.6831 27.0992 35.6776 27.0909 35.6739 27.0817C35.6702 27.0725 35.6683 27.0627 35.6684 27.0528V10.3627H60.3316V27.0521C60.3318 27.062 60.33 27.0718 60.3264 27.081C60.3228 27.0902 60.3173 27.0986 60.3104 27.1058C60.3035 27.1129 60.2953 27.1185 60.2862 27.1224C60.2771 27.1263 60.2673 27.1284 60.2574 27.1285Z" />
                  <path d="M42.0915 7.16298C42.2759 7.16298 42.4257 7.01311 42.4257 6.82877V2.33421C42.4257 2.29032 42.4171 2.24686 42.4003 2.20631C42.3835 2.16576 42.3589 2.12892 42.3279 2.09789C42.2968 2.06685 42.26 2.04224 42.2194 2.02544C42.1789 2.00864 42.1354 2 42.0915 2C42.0476 2 42.0042 2.00864 41.9636 2.02544C41.9231 2.04224 41.8862 2.06685 41.8552 2.09789C41.8242 2.12892 41.7996 2.16576 41.7828 2.20631C41.766 2.24686 41.7573 2.29032 41.7573 2.33421V6.82952C41.7573 7.01386 41.9072 7.16298 42.0915 7.16298Z" />
                  <path d="M54.1965 7.16298C54.3809 7.16298 54.5307 7.01311 54.5307 6.82877V2.33421C54.5307 2.24557 54.4955 2.16056 54.4328 2.09789C54.3702 2.03521 54.2852 2 54.1965 2C54.1079 2 54.0229 2.03521 53.9602 2.09789C53.8975 2.16056 53.8623 2.24557 53.8623 2.33421V6.82952C53.8623 7.01386 54.0114 7.16298 54.1965 7.16298Z" />
                  <path d="M40.3646 15.4185C41.3818 15.4185 42.2065 14.5939 42.2065 13.5766C42.2065 12.5594 41.3818 11.7347 40.3646 11.7347C39.3473 11.7347 38.5227 12.5594 38.5227 13.5766C38.5227 14.5939 39.3473 15.4185 40.3646 15.4185Z" />
                  <path d="M45.6583 15.4185C46.6755 15.4185 47.5002 14.5939 47.5002 13.5766C47.5002 12.5594 46.6755 11.7347 45.6583 11.7347C44.641 11.7347 43.8164 12.5594 43.8164 13.5766C43.8164 14.5939 44.641 15.4185 45.6583 15.4185Z" />
                  <path d="M50.9505 15.4185C51.9678 15.4185 52.7924 14.5939 52.7924 13.5766C52.7924 12.5594 51.9678 11.7347 50.9505 11.7347C49.9333 11.7347 49.1086 12.5594 49.1086 13.5766C49.1086 14.5939 49.9333 15.4185 50.9505 15.4185Z" />
                  <path d="M40.3646 20.5478C41.3818 20.5478 42.2065 19.7231 42.2065 18.7059C42.2065 17.6887 41.3818 16.864 40.3646 16.864C39.3473 16.864 38.5227 17.6887 38.5227 18.7059C38.5227 19.7231 39.3473 20.5478 40.3646 20.5478Z" />
                  <path d="M45.6583 20.5478C46.6755 20.5478 47.5002 19.7231 47.5002 18.7059C47.5002 17.6887 46.6755 16.864 45.6583 16.864C44.641 16.864 43.8164 17.6887 43.8164 18.7059C43.8164 19.7231 44.641 20.5478 45.6583 20.5478Z" />
                  <path d="M50.9505 20.5478C51.9678 20.5478 52.7924 19.7231 52.7924 18.7059C52.7924 17.6887 51.9678 16.864 50.9505 16.864C49.9333 16.864 49.1086 17.6887 49.1086 18.7059C49.1086 19.7231 49.9333 20.5478 50.9505 20.5478Z" />
                  <path d="M40.3646 25.6771C41.3818 25.6771 42.2065 24.8524 42.2065 23.8352C42.2065 22.8179 41.3818 21.9933 40.3646 21.9933C39.3473 21.9933 38.5227 22.8179 38.5227 23.8352C38.5227 24.8524 39.3473 25.6771 40.3646 25.6771Z" />
                  <path d="M45.6583 25.6771C46.6755 25.6771 47.5002 24.8524 47.5002 23.8352C47.5002 22.8179 46.6755 21.9933 45.6583 21.9933C44.641 21.9933 43.8164 22.8179 43.8164 23.8352C43.8164 24.8524 44.641 25.6771 45.6583 25.6771Z" />
                  <path d="M50.9505 25.6771C51.9678 25.6771 52.7924 24.8524 52.7924 23.8352C52.7924 22.8179 51.9678 21.9933 50.9505 21.9933C49.9333 21.9933 49.1086 22.8179 49.1086 23.8352C49.1086 24.8524 49.9333 25.6771 50.9505 25.6771Z" />
                  <path d="M56.12 15.4185C57.1372 15.4185 57.9619 14.5939 57.9619 13.5766C57.9619 12.5594 57.1372 11.7347 56.12 11.7347C55.1027 11.7347 54.2781 12.5594 54.2781 13.5766C54.2781 14.5939 55.1027 15.4185 56.12 15.4185Z" />
                  <path d="M56.12 20.5478C57.1372 20.5478 57.9619 19.7231 57.9619 18.7059C57.9619 17.6887 57.1372 16.864 56.12 16.864C55.1027 16.864 54.2781 17.6887 54.2781 18.7059C54.2781 19.7231 55.1027 20.5478 56.12 20.5478Z" />
                  <path d="M56.12 25.6771C57.1372 25.6771 57.9619 24.8524 57.9619 23.8352C57.9619 22.8179 57.1372 21.9933 56.12 21.9933C55.1027 21.9933 54.2781 22.8179 54.2781 23.8352C54.2781 24.8524 55.1027 25.6771 56.12 25.6771Z" />
                  <line x1="0.5" y1="2.18557e-08" x2="0.499999" y2="30" />
                </svg>
              </div>
            </div>
          </div>
        )}
      </div> */}

      <div className="border-b-2 border-b-gray-200 my-4"></div>

      {/* {(profile?.role == "superAdmin" || profile?.role == "admin") && (
        <div>
          <ContactDetails adminId={id} />
          <hr className="my-4" />
        </div>
      )} */}
      <div className="px-[30px]">
        {/* <div>
          <div className="t2_sp_work_title" style={{ marginTop: 48 }}>
            Available for other location
          </div>
          <div className="ssu2_modal1_input">
            <div className="ssu2_modal1_input ssu2_modal3_selectBox">
              <div className="input_left_email_icon">
                <img width="18px" height="15px" alt="img" src={place} />
              </div>
              <input
                className="ssu2_modal3_select w-[436px] h-auto"
                placeholder="Zip Code"
                type="text"
                value={zipCode}
                name="zipCode"
                onChange={(e) => setZipCode(e.target.value)}
                onKeyUp={(e) => {
                  if (e.key) getCityStateData();
                }}
              />
            </div>
          </div>
        </div> */}

        <div className="ssu2_modal1_input ssu2_modal3_selectBox mb-2">
          <div className=" flex flex-col gap-4">
            <div>
              <h1 className="flex  cardHeading items-center">
                Functional Area
                <span className="text-red-700">*</span>
                <img
                  width="14px"
                  className="cursor-pointer ml-1"
                  height="14px"
                  alt="img"
                  src={iIcon}
                  data-tooltip-id="functional-tooltip"
                />
                <ReactTooltip
                  id="functional-tooltip"
                  place="right"
                  type="dark"
                  className="custom-tooltip"
                  content="A specific domain or department where a professional performs their core job duties"
                />
              </h1>

              {userData.FunctionalArea && (
                <>
                  {" "}
                  <div
                    className="relative md:min-w-[338px] flex items-center justify-between overflow-hidden"
                    style={{
                      border: "1px solid #0000001A",
                      boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.1)",
                      borderRadius: "10px",
                      padding: "20px 20px",
                      minHeight: "70px",
                      display: "inline-flex",
                    }}
                  >
                    <p className="boxText truncate max-w-[90%] pr-2">
                      {userData.FunctionalArea}
                    </p>

                    {(profile?.role == "staff" ||
                      profile?.role == "superAdmin") && (
                      <img
                        className="cursor-pointer"
                        width="18px"
                        height="15px"
                        alt="img"
                        src={edit_note}
                        onClick={() => {
                          const selectedArea = functionalOption.find((item) => {
                            return item.label === userData.FunctionalArea;
                          });

                          if (selectedArea) {
                            setSelectedFunctionalArea(
                              userData.FunctionalArea || ""
                            );
                          } else {
                            setSelectedFunctionalArea("Other");
                            setOtherFunctionalValue(userData.FunctionalArea);
                          }

                          setFunctionalAreaOpen(true);
                        }}
                      />
                    )}
                  </div>
                  <Modal
                    isOpen={functionalAreaOpen}
                    onClose={() => setFunctionalAreaOpen(false)}
                    className="md:w-1/3 md:mt-0  "
                  >
                    <div
                      className="d-flex flex-col gap-3 items-center justify-center p-0"
                      style={{ background: "#fff", borderRadius: "15px" }}
                    >
                      <div className="d-flex" style={{ width: "100%" }}>
                        <div
                          onClick={() => setFunctionalAreaOpen(false)}
                          className="cursor-pointer"
                        >
                          <svg
                            width="24"
                            height="20"
                            viewBox="0 0 30 26"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M30 10.927H6.23656L14.8599 2.30368L12.5562 0L0 12.5562L12.5562 25.1124L14.8599 22.8087L6.23656 14.1854H30V10.927Z"
                              fill="#333333"
                            />
                          </svg>
                        </div>
                        <h1
                          className="mb-3"
                          style={{ fontSize: "25px", margin: "auto" }}
                        >
                          Edit Functional Area
                        </h1>
                      </div>
                      <div className="flex flex-col gap-4">
                        {" "}
                        <div className=" w-[372px]">
                          {" "}
                          <CustomSelect
                            options={[
                              ...functionalOption,
                              { label: "Other", value: "Other" },
                            ]}
                            selected={selectedFunctionalArea}
                            onChange={handleFunctionalAreaChange}
                          />
                        </div>
                        {showfunctionalOther && (
                          <input
                            type="text"
                            className="ssu2_modal3_select w-[372px]"
                            value={otherfunctionalValue}
                            placeholder="Enter your Functional Area"
                            onChange={(e) => {
                              setOtherFunctionalValue(e.target.value);
                            }}
                          />
                        )}
                        <button
                          className="w-full bg-[#73C7A9] text-white rounded-[28px] p-2 max-w-[372px]"
                          onClick={() => {
                            const valueToSave =
                              selectedFunctionalArea === "Other"
                                ? otherfunctionalValue.trim()
                                : selectedFunctionalArea;
                            if (!valueToSave) {
                              showErrorToast("Please enter a Functional Area");
                              return;
                            }
                            setOtherFunctionalValue("");
                            if (selectedFunctionalArea === "Other") {
                              setSelectedSpecialization("Other");
                              setSpecializationOption([]);
                            }
                            setUpdateAllData({
                              FunctionalArea: showfunctionalOther
                                ? otherfunctionalValue
                                : selectedFunctionalArea,
                            });
                            setFunctionalAreaOpen(false);
                          }}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </Modal>
                </>
              )}
            </div>
            <div>
              <h1 className="flex cardHeading items-center">
                Specialization
                <span className="text-red-700">*</span>
                <img
                  className="cursor-pointer ml-1"
                  width="14px"
                  height="14px"
                  alt="img"
                  src={iIcon}
                  data-tooltip-id="specialization-tooltip"
                />
                <ReactTooltip
                  id="specialization-tooltip"
                  place="right"
                  type="dark"
                  className="custom-tooltip"
                  content="Specific medical field a doctor focuses on after general training."
                />
              </h1>

              {userData.Specialization && (
                <>
                  {" "}
                  <div
                    className="relative md:min-w-[338px] flex items-center justify-between overflow-hidden"
                    style={{
                      border: "1px solid #0000001A",
                      boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.1)",
                      borderRadius: "10px",
                      padding: "20px 20px",
                      minHeight: "70px",
                      display: "inline-flex",
                    }}
                  >
                    <p className="boxText truncate max-w-[90%] pr-2">
                      {userData.Specialization}
                    </p>
                    {(profile?.role == "staff" ||
                      profile?.role == "superAdmin") && (
                      <img
                        className="cursor-pointer"
                        width="18px"
                        height="15px"
                        alt="img"
                        src={edit_note}
                        onClick={() => {
                          const findSpecialization = specializationOption.find(
                            (item) => {
                              return item.label === userData.Specialization;
                            }
                          );

                          if (selectedFunctionalArea === "Other") {
                            setSelectedSpecialization("Other");
                            setShowOtherProfessional(true);
                            setSpecializationVal(userData.Specialization || "");
                          } else if (!findSpecialization) {
                            setSelectedSpecialization("Other");
                            setShowOtherProfessional(true);
                            setSpecializationVal(userData.Specialization || "");
                          } else {
                            setSelectedSpecialization(
                              userData.Specialization || ""
                            );
                          }

                          setSpecializationOpen(true);
                        }}
                      />
                    )}
                  </div>
                  <Modal
                    isOpen={specializationOpen}
                    onClose={() => setSpecializationOpen(false)}
                    className="md:w-1/3 md:mt-0"
                  >
                    <div
                      className="d-flex flex-col gap-3 items-center justify-center p-0"
                      style={{ background: "#fff", borderRadius: "15px" }}
                    >
                      <div className="d-flex" style={{ width: "100%" }}>
                        <div
                          onClick={() => setSpecializationOpen(false)}
                          className="cursor-pointer"
                        >
                          <svg
                            width="24"
                            height="20"
                            viewBox="0 0 30 26"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M30 10.927H6.23656L14.8599 2.30368L12.5562 0L0 12.5562L12.5562 25.1124L14.8599 22.8087L6.23656 14.1854H30V10.927Z"
                              fill="#333333"
                            />
                          </svg>
                        </div>
                        <h1
                          className="mb-3"
                          style={{ fontSize: "25px", margin: "auto" }}
                        >
                          Edit Specialization
                        </h1>
                      </div>
                      <div className="flex flex-col gap-4">
                        {" "}
                        <div className=" w-[372px]">
                          {" "}
                          <CustomSelect
                            options={[
                              ...specializationOption,
                              { label: "Other", value: "Other" },
                            ]}
                            selected={selectedSpecialization}
                            onChange={(val) => {
                              setSelectedSpecialization(val);
                              if (val === "Other") {
                                setShowOtherProfessional(true);
                              } else {
                                setShowOtherProfessional(false);
                              }
                            }}
                          />
                        </div>
                        {showOtherProfessional && (
                          <input
                            type="text"
                            className="ssu2_modal3_select w-[372px] "
                            value={specializationVal}
                            onChange={(e) =>
                              setSpecializationVal(e.target.value)
                            }
                            placeholder="Enter you Specialization"
                          />
                        )}
                        <button
                          className="w-full bg-[#73C7A9] text-white rounded-[28px] p-2 max-w-[372px]"
                          onClick={() => {
                            const valueToSave = showOtherProfessional
                              ? specializationVal.trim()
                              : selectedSpecialization;

                            if (!valueToSave) {
                              showErrorToast("Please enter a Specialization");
                              return;
                            }
                            setUpdateAllData({
                              Specialization: showOtherProfessional
                                ? specializationVal
                                : selectedSpecialization,
                              jobTitle: showOtherProfessional
                                ? specializationVal
                                : selectedSpecialization,
                            });
                            setSpecializationOpen(false);
                          }}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </Modal>
                </>
              )}
            </div>
            <div>
              <h1 className="flex cardHeading items-center">
                Current Professional Status
                <span className="text-red-700">*</span>
                <img
                  className="cursor-pointer ml-1"
                  width="14px"
                  height="14px"
                  alt="img"
                  src={iIcon}
                  data-tooltip-id="professional-tooltip"
                />
                <ReactTooltip
                  id="professional-tooltip"
                  place="right"
                  type="dark"
                  className="custom-tooltip"
                  content="It indicates a staff's present role or employment situation in their career."
                />
              </h1>

              {/* <div
                  className="mt-3 relative min-w-[338px] flex items-center justify-between"
                  style={{
                    border: "1px solid #0000001A",
                    boxShadow: " 0px 0px 4px rgba(0, 0, 0, 0.1)", // Adjust shadow for 3D look
                    borderRadius: "10px",
                    padding: "20px 20px",
                    minHeight: "70px",
                    display: "inline-flex",
                  }}
                >
                  <p>Nephrologist</p>
                  <img
                    className="cursor-pointer"
                    width="18px"
                    height="15px"
                    alt="img"
                    src={edit_note}
                    onClick={certopenModal}
                  />
                </div> */}
              <div
                className=" relative md:min-w-[338px] flex items-center justify-between"
                style={{
                  border: "1px solid #0000001A",
                  boxShadow: " 0px 0px 4px rgba(0, 0, 0, 0.1)", // Adjust shadow for 3D look
                  borderRadius: "10px",
                  padding: "20px 20px",
                  minHeight: "70px",
                  display: "inline-flex",
                }}
              >
                <p className="boxText">{userData.currentProfessionalStatus}</p>
                {(profile?.role == "staff" ||
                  profile?.role == "superAdmin") && (
                  <img
                    className="cursor-pointer"
                    width="18px"
                    height="15px"
                    alt="img"
                    src={edit_note}
                    onClick={() => {
                      setSpecializationVal(userData.Specialization || "");
                      setProfessionalOpen(true);
                    }}
                  />
                )}
              </div>
            </div>

            {/* <select
                className="ssu2_modal3_select w-1/2 max-w-[50%] h-auto"
                name="option"
                onChange={optionstateopenModal}
                value={nursingStateVal}
              >
                <option value="" disabled customhidden>
                  Select a state to add a nursing License
                </option>
                {stateOfUs?.map((state) => {
                  return (
                    <option key={state.num} value={state._id}>
                      {" "}
                      {state}{" "}
                    </option>
                  );
                })}
              </select> */}
            <Modal
              isOpen={professionalOpen}
              onClose={() => setProfessionalOpen(false)}
              className={"md:w-1/3 md:mt-0"}
            >
              <div
                className="d-flex flex-col  gap-3 items-center justify-center p-0"
                style={{ background: "#fff", borderRadius: "15px" }}
              >
                <div className="d-flex" style={{ width: "100%" }}>
                  <div
                    onClick={() => setProfessionalOpen(false)}
                    className="cursor-pointer"
                  >
                    <svg
                      width="24"
                      height="20"
                      viewBox="0 0 30 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M30 10.927H6.23656L14.8599 2.30368L12.5562 0L0 12.5562L12.5562 25.1124L14.8599 22.8087L6.23656 14.1854H30V10.927Z"
                        fill="#333333"
                      />
                    </svg>
                  </div>
                  <h1
                    className="mb-3"
                    style={{ fontSize: "25px", margin: "auto" }}
                  >
                    Edit Professional Status
                  </h1>
                </div>
                <div className="flex flex-col gap-4">
                  {" "}
                  <div className=" w-[372px]">
                    {" "}
                    <CustomSelect
                      options={[...professionalOption]}
                      selected={selected}
                      onChange={(val) => {
                        setSelected(val);
                      }}
                    />
                  </div>
                  {/* {showOtherProfessional && (
                    <input
                      type="text"
                      placeholder="Enter your professional status"
                      className="ssu2_modal3_select w-full my-3"
                      value={customProfessionalStatus}
                      onChange={(e) =>
                        setCustomProfessionalStatus(e.target.value)
                      }
                    />
                  )} */}
                  <button
                    className="w-full bg-[#73C7A9] text-white rounded-[28px] p-2 max-w-[372px]"
                    onClick={() => {
                      setUpdateAllData({
                        currentProfessionalStatus: selected,
                      });
                      setProfessionalOpen(false);
                    }}
                  >
                    Save
                  </button>
                </div>
              </div>
            </Modal>
          </div>

          <Modal
            isOpen={optionstateOpens}
            onClose={optionstatecloseModal}
            className={"md:w-1/2 md:mt-0"}
          >
            <div
              className="d-flex flex-col items-center justify-center"
              style={{ background: "#fff", borderRadius: "15px" }}
            >
              <div className="d-flex" style={{ width: "100%" }}>
                <div onClick={optionstatecloseModal}>
                  <svg
                    width="24"
                    height="20"
                    viewBox="0 0 30 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M30 10.927H6.23656L14.8599 2.30368L12.5562 0L0 12.5562L12.5562 25.1124L14.8599 22.8087L6.23656 14.1854H30V10.927Z"
                      fill="#333333"
                    />
                  </svg>
                </div>
                <h1
                  className="mb-3"
                  style={{ fontSize: "25px", margin: "auto" }}
                >
                  Add License
                </h1>
              </div>
              <div className="ssu2_modal1_input ssu2_modal3_selectBox">
                <div className="input_left_icon">
                  <img alt="img" width="18px" height="15px" src={jobTitle} />
                </div>
                <input
                  className="ssu2_modal3_select"
                  placeholder="License Name"
                  type="text"
                  value={addLicense?.name}
                  onChange={(e) => {
                    setAddLicense((prev) => ({
                      ...prev,
                      name: e.target.value,
                    }));
                  }}
                />
              </div>
              <div className="ssu2_modal1_input ssu2_modal3_selectBox">
                <div className="input_left_icon">
                  <img alt="img" width="18px" height="15px" src={jobTitle} />
                </div>
                <input
                  className="ssu2_modal3_select"
                  placeholder="License number"
                  type="text"
                  value={addLicense?.number}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    const filteredValue = inputValue.replace(
                      /[^a-zA-Z0-9]/g,
                      ""
                    );
                    setAddLicense((prev) => ({
                      ...prev,
                      number: filteredValue,
                    }));
                  }}
                />
                <div className="ssu2_modal1_input ssu2_modal3_selectBox">
                  <DatePicker
                    selected={
                      addLicense?.expirationDate
                        ? new Date(addLicense?.expirationDate)
                        : ""
                    }
                    onChange={(e) => {
                      setAddLicense((prev) => ({
                        ...prev,
                        expirationDate: e,
                      }));
                    }}
                    showYearDropdown
                    showMonthDropdown
                    dropdownMode="select"
                    dateFormat="MM/dd/yyyy"
                    placeholderText="Select date"
                    className="ssu2_modal3_select"
                    style={{ maxWidth: "800px", Width: "100%" }}
                  />
                  <div className="input_left_post_icon">
                    <img width="18px" height="15px" alt="img" src={calendar} />
                  </div>
                </div>
                <div className="ssu2_modal1_input ssu2_modal3_selectBox text-center">
                  <div
                    className="relative"
                    style={{
                      border: "1px solid #cccccc",
                      boxShadow: "0px 0px 2px #cccccc",
                      padding: "25px 15px",
                    }}
                  >
                    <h3>Please upload Your license</h3>
                    {addLicense?.image && (
                      <div className="text-center my-3 flex justify-center">
                        <img
                          src={URL.createObjectURL(addLicense.image)}
                          alt="Uploaded License"
                          style={{
                            maxWidth: "100%",
                            maxHeight: "100px",
                            borderRadius: "12px",
                          }}
                        />
                      </div>
                    )}
                    <div
                      className="flex justify-center mb-3.5"
                      style={{ cursor: "pointer" }}
                    >
                      <button className="w-[200px] h-[44px] border border-[#333333]-700 rounded-[100px] text-sm text-[#333333] cursor-pointer hover:!cursor-pointer absolute">
                        UPLOAD YOUR LICENSE
                      </button>
                      <input
                        type="file"
                        accept="image/*"
                        className="opacity-0 w-[100px]"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            setAddLicense((prev) => ({
                              ...prev,
                              image: file,
                            }));
                          }
                        }}
                      />
                    </div>
                    <h3>Please upload only png,jpg,or jpeg images</h3>
                  </div>
                </div>
                <button
                  className="ssu2_modal1_button1 text-white bg-[#73C7A9] rounded-[28px] p-2 mt-3"
                  style={{ width: "100%" }}
                  onClick={() => {
                    setUpdateNursingLicense(addLicense);
                  }}
                >
                  SAVE
                </button>
              </div>
            </div>
          </Modal>
          <Modal
            isOpen={nursdelaOpens}
            onClose={() => setnursdelaOpens(false)}
            className={"md:w-1/2 md:mt-0"}
          >
            <div
              className="d-flex flex-col items-center justify-center p-0"
              style={{
                background: "#fff",
                borderRadius: "15px",
              }}
            >
              <div className="d-flex" style={{ width: "100%" }}>
                <div onClick={() => setnursdelaOpens(false)}>
                  <svg
                    width="24"
                    height="20"
                    viewBox="0 0 30 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M30 10.927H6.23656L14.8599 2.30368L12.5562 0L0 12.5562L12.5562 25.1124L14.8599 22.8087L6.23656 14.1854H30V10.927Z"
                      fill="#333333"
                    />
                  </svg>
                </div>
                <h1
                  className="mb-3"
                  style={{ fontSize: "25px", margin: "auto" }}
                >
                  Edit License
                </h1>
              </div>
              <div>
                <div className="ssu2_modal1_input ssu2_modal3_selectBox">
                  <div className="input_left_icon">
                    <img alt="img" width="18px" height="15px" src={jobTitle} />
                  </div>
                  <input
                    className="ssu2_modal3_select"
                    placeholder="License Name"
                    type="text"
                    onChange={(e) =>
                      setLicenseFormData((prev) => ({
                        ...prev,
                        name: e.target.value,
                      }))
                    }
                    value={licenseFormData?.name}
                  />
                </div>
                <div className="ssu2_modal1_input ssu2_modal3_selectBox">
                  <div className="input_left_icon">
                    <img alt="img" width="18px" height="15px" src={jobTitle} />
                  </div>
                  <input
                    className="ssu2_modal3_select"
                    placeholder="License Number"
                    type="text"
                    // defaultValue={data?.number}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      const filteredValue = inputValue.replace(
                        /[^a-zA-Z0-9]/g,
                        ""
                      );
                      setLicenseFormData((prev) => ({
                        ...prev,
                        number: e.target.value,
                      }));
                    }}
                    value={licenseFormData?.number}
                  />
                </div>
                <div className="ssu2_modal1_input ssu2_modal3_selectBox">
                  <DatePicker
                    selected={
                      licenseFormData?.expirationDate
                        ? new Date(licenseFormData?.expirationDate)
                        : ""
                    }
                    onChange={(e) => {
                      setLicenseFormData((prev) => ({
                        ...prev,
                        expirationDate: e,
                      }));
                    }}
                    showYearDropdown
                    showMonthDropdown
                    dropdownMode="select"
                    className="ssu2_modal3_select pl-[60px]"
                    placeholderText="Expiration Date"
                  />
                  <div className="input_left_post_icon">
                    <img width="18px" height="15px" alt="img" src={calendar} />
                  </div>
                </div>
                <div className="ssu2_modal1_input ssu2_modal3_selectBox text-center">
                  {licenseFormData?.image && (
                    <div className="text-center mt-3 flex justify-center">
                      <img
                        src={
                          licenseFormData?.image?.name
                            ? URL.createObjectURL(licenseFormData?.image)
                            : licenseFormData?.image
                        }
                        alt="Uploaded License"
                        style={{
                          maxWidth: "100%",
                          maxHeight: "100px",
                          borderRadius: "12px",
                        }}
                      />
                    </div>
                  )}
                  <h1 className="mb-2">Please upload your license</h1>
                  <div className="relative">
                    <div
                      className="flex justify-center mb-3.5"
                      style={{ cursor: "pointer" }}
                    >
                      <button className="w-[200px] h-[44px] border border-[#333333]-700 rounded-[100px] text-sm text-[#333333] cursor-pointer hover:!cursor-pointer absolute">
                        Upload Your License
                      </button>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            setLicenseFormData((prev) => ({
                              ...prev,
                              image: file,
                            }));
                          }
                        }}
                        style={{ height: "44px !important" }}
                        className="opacity-0 mt-0 !h-11 w-auto cursor-pointer"
                      />
                    </div>
                    <h3>Please upload only png,jpg,or jpeg images</h3>
                  </div>
                  <button
                    className="ssu2_modal1_button1 text-white bg-[#73C7A9] rounded-[28px] p-2 mt-3"
                    style={{ width: "100%" }}
                    onClick={saveLicenseData}
                  >
                    SAVE
                  </button>
                </div>
              </div>
            </div>
          </Modal>

          {userData?.nursingLicense?.map((data, index) => {
            const isAccordionOpen = accordionItemStates[index];
            const toggleAccordion = () => {
              const newAccordionItemStates = [...accordionItemStates];
              newAccordionItemStates[index] = !newAccordionItemStates[index];
              setAccordionItemStates(newAccordionItemStates);
            };
            return (
              <div className="accordion">
                <div
                  className="accordion-header flex t2_sp_work_title pointer"
                  style={{ marginTop: 48, cursor: "pointer" }}
                  onClick={toggleAccordion}
                >
                  {isAccordionOpen ? (
                    <KeyboardArrowDownIcon className="h-4 w-4 mr-10" />
                  ) : (
                    <KeyboardArrowRightIcon className="h-4 w-4 mr-2" />
                  )}
                  <h1>{data.state}</h1>
                </div>
                {!isAccordionOpen}
                {isAccordionOpen && (
                  <>
                    <div className="accordion-content mt-4">
                      <div
                        className="d-flex justify-between py-4 px-5 mt-3 w-[436px] h-auto relative"
                        style={{
                          border: "1px solid darkgrey",
                          borderRadius: "12px",
                        }}
                      >
                        <div>
                          <div className="mb-5">
                            <h1>Name</h1>
                            <h1>{data?.name}</h1>
                          </div>
                          <div>
                            <h1>Number</h1>
                            <h1>{data?.number}</h1>
                          </div>
                        </div>

                        <div className="justify-between flex flex-col">
                          <div className="d-flex justify-end gap-3">
                            <img
                              className="rounded-xl mr-[60%]"
                              width="50px"
                              height="50px"
                              alt="img"
                              src={data?.image}
                            />
                            <div className="flex top-4 right-4 absolute gap-4">
                              {(profile?.role == "staff" ||
                                profile?.role == "superAdmin") && (
                                <img
                                  className="cursor-pointer"
                                  width="18px"
                                  height="15px"
                                  alt="img"
                                  src={edit_note}
                                  onClick={() => {
                                    nursdelaopenModal();
                                    setLicenseFormData(
                                      state?.nursingLicense?.[index]
                                    );
                                    setMappingIndexes((prev) => ({
                                      ...prev,
                                      licenseIndex: index,
                                    }));
                                  }}
                                />
                              )}

                              {(profile?.role == "staff" ||
                                profile?.role == "superAdmin") && (
                                <img
                                  className="cursor-pointer"
                                  width="18px"
                                  height="15px"
                                  alt="img"
                                  onClick={() =>
                                    deleteDetails({ name: "nursinglic", index })
                                  }
                                  src={trans}
                                />
                              )}
                            </div>
                          </div>
                          <div>
                            <h1>Expiration Date</h1>
                            <h1>
                              {data.expirationDate == null ? (
                                <>
                                  {new Date().toLocaleDateString("en-US", {
                                    month: "2-digit",
                                    day: "2-digit",
                                    year: "numeric",
                                  })}
                                </>
                              ) : (
                                <>
                                  {moment(data.expirationDate).format(
                                    "MM-DD-YYYY"
                                  )}
                                </>
                              )}
                            </h1>
                          </div>
                        </div>
                      </div>
                    </div>
                    {isAccordionOpen}
                  </>
                )}
              </div>
            );
          })}

          {/* <div className="accordion">
          <div
            className="accordion-header t2_sp_work_title"
            style={{ marginTop: 48 }}
            onClick={nursaAccordion}
          >
            <h1>Alaska</h1>
          </div>
          {nursaOpen && (
            <div className="accordion-content">
              <h2>Please provide your nursing license details</h2>
              <div
                className="d-flex justify-between p-4 my-3"
                style={{ border: "1px solid darkgrey", borderRadius: "15px" }}
              >
                <div>
                  <div className="mb-3">
                    <h1>Name</h1>
                    <h1>p test ios</h1>
                  </div>
                  <div>
                    <h1>Number</h1>
                    <h1>p ios</h1>
                  </div>
                </div>
                {nursdelaOpens && (
                  <div className="fixed inset-0 flex items-center justify-center z-50">
                    <div className="absolute inset-0 bg-black opacity-50"></div>
                    <div className=" z-10 w-full h-full max-w-[500px] max-h-[435px] ">
                      <div
                        className="d-flex flex-col items-center justify-center p-0"
                        style={{ background: "#fff", borderRadius: "15px" }}
                      >
                        <div className="d-flex" style={{ width: "100%" }}>
                          <div onClick={nursdelacloseModal}>
                            <svg
                              width="24"
                              height="20"
                              viewBox="0 0 30 26"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M30 10.927H6.23656L14.8599 2.30368L12.5562 0L0 12.5562L12.5562 25.1124L14.8599 22.8087L6.23656 14.1854H30V10.927Z"
                                fill="#73C7A9"
                              />
                            </svg>
                          </div>
                          <h1
                            className="mb-5"
                            style={{ fontSize: "25px", margin: "auto" }}
                          >
                            Edit License
                          </h1>
                        </div>
                        <div>
                          <div className="ssu2_modal1_input ssu2_modal3_selectBox">
                            <div className="input_left_icon">
                              <img
                                alt="img"
                                width="18px"
                                height="15px"
                                src={jobTitle}
                              />
                            </div>
                            <input
                              className="ssu2_modal3_select"
                              placeholder="License Name"
                              type="text"
                            />
                          </div>
                          <div className="ssu2_modal1_input ssu2_modal3_selectBox">
                            <div className="input_left_icon">
                              <img
                                alt="img"
                                width="18px"
                                height="15px"
                                src={jobTitle}
                              />
                            </div>
                            <input
                              className="ssu2_modal3_select"
                              placeholder="License Number"
                              type="text"
                            />
                          </div>
                          <div className="ssu2_modal1_input ssu2_modal3_selectBox">
                            <DatePicker
                              selected={testDate}
                              onChange={(date) => setTestDate(date)}
                              dateFormat="MM/dd/yyyy"
                              placeholderText="Select date"
                              className="ssu2_modal3_select"
                              style={{ maxWidth: "800px", Width: "100%" }}
                            />
                            <div className="input_left_post_icon">
                              <img
                                width="18px"
                                height="15px"
                                alt="img"
                                src={calendar}
                              />
                            </div>
                          </div>
                          <div className="ssu2_modal1_input ssu2_modal3_selectBox text-center">
                            <h1 className="mb-2">Please upload your license</h1>
                            <div className="relative">
                              <div
                                className="flex justify-center mb-3.5"
                                style={{ cursor: "pointer" }}
                              >
                                <button className="w-[200px] h-[44px] border border-[#333333]-700 rounded-[100px] text-sm text-[#333333] cursor-pointer hover:!cursor-pointer absolute">
                                  Upload Your License
                                </button>
                                <input
                                  type="file"
                                  accept="image/*"
                                  className="opacity-0 w-[100px]"
                                />
                              </div>
                              <h3>Please upload only png,jpg,or jpeg images</h3>
                            </div>
                            <button
                              className="ssu2_modal1_button1 text-white bg-[#73C7A9] rounded-[28px] p-2 mt-3"
                              style={{ width: "100%" }}
                            >
                              SAVE
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div>
                  <h1>Expiration Date</h1>
                  <h1>09/01/2023</h1>
                </div>
                <div className="d-flex justify-end gap-3">
                  <img
                    className="cursor-pointer"
                    width="18px"
                    height="15px"
                    alt="img"
                    src={edit_note}
                    onClick={nursdelaopenModal}
                  />
                  <img
                    className="cursor-pointer"
                    width="18px"
                    height="15px"
                    alt="img"
                    src={trans}
                  />
                </div>
              </div>
            </div>
          )}
        </div>

        <hr className="my-3" /> */}
        </div>
      </div>

      <hr className="my-4" />
      {/* <div className="flex items-center gap-10 px-[30px]">
        <div className="">
          <div
            className="t2_sp_work_title"
            style={{ marginTop: 20, fontSize: "24px" }}
          >
            Liability insurance
          </div>
          <div
            className="ssu2_addItem flex border !border-[#73C7A9] rounded-[25px] w-[436px] h-auto py-[14px] px-[20px] text-[16px]"
            onClick={insuropenModal}
          >
            + Add Liability Insurance
          </div>
          <Modal
            isOpen={insuranceOpens}
            onClose={insurcloseModal}
            className={"md:w-1/2 md:mt-0"}
          >
            <div
              className="d-flex flex-col items-center justify-center p-0"
              style={{ background: "#fff", borderRadius: "15px" }}
            >
              <div className="d-flex" style={{ width: "100%" }}>
                <div onClick={insurcloseModal}>
                  <svg
                    width="24"
                    height="20"
                    viewBox="0 0 30 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M30 10.927H6.23656L14.8599 2.30368L12.5562 0L0 12.5562L12.5562 25.1124L14.8599 22.8087L6.23656 14.1854H30V10.927Z"
                      fill="#73C7A9"
                    />
                  </svg>
                </div>
                <h1
                  className="mb-5"
                  style={{ fontSize: "25px", margin: "auto" }}
                >
                  Add Liability Insurance
                </h1>
              </div>
              <div className="ssu2_modal1_input ssu2_modal3_selectBox">
                <div className="input_left_icon">
                  <img alt="img" width="18px" height="15px" src={jobTitle} />
                </div>
                <input
                  className="ssu2_modal3_select"
                  placeholder="Insurance provider"
                  type="text"
                />
              </div>
              <div className="ssu2_modal1_input ssu2_modal3_selectBox">
                <div className="input_left_icon">
                  <img alt="img" width="18px" height="15px" src={jobTitle} />
                </div>
                <input
                  className="ssu2_modal3_select"
                  placeholder="Police number"
                  type="number"
                />
                <button
                  className="ssu2_modal1_button1 text-white bg-[#73C7A9] rounded-[28px] p-2 mt-3"
                  style={{ width: "100%" }}
                >
                  SAVE
                </button>
              </div>
            </div>
          </Modal>
        </div>
        <div className="">
          <div
            className="t2_sp_work_title"
            style={{ marginTop: 20, fontSize: "24px" }}
          >
            Drug Test
          </div>
          <div
            className="ssu2_addItem flex border !border-[#73C7A9] rounded-[25px] w-[436px] h-auto py-[14px] px-[20px] text-[16px]"
            onClick={drugopenModal}
          >
            + Add Drug Test
          </div>
          <Modal
            isOpen={drugOpens}
            onClose={drugcloseModal}
            className={"md:w-1/2 md:mt-0"}
          >
            <div
              className="d-flex flex-col items-center justify-center p-0"
              style={{ background: "#fff", borderRadius: "15px" }}
            >
              <div className="d-flex" style={{ width: "100%" }}>
                <div onClick={drugcloseModal}>
                  <svg
                    width="24"
                    height="20"
                    viewBox="0 0 30 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M30 10.927H6.23656L14.8599 2.30368L12.5562 0L0 12.5562L12.5562 25.1124L14.8599 22.8087L6.23656 14.1854H30V10.927Z"
                      fill="#73C7A9"
                    />
                  </svg>
                </div>
                <h1
                  className="mb-5"
                  style={{ fontSize: "25px", margin: "auto" }}
                >
                  Add Drug Test
                </h1>
              </div>
              <div>
                <div className="ssu2_modal1_input ssu2_modal3_selectBox">
                  <div
                    className="relative"
                    style={{
                      border: "1px solid #cccccc",
                      boxShadow: "0px 0px 2px #cccccc",
                      padding: "25px 15px",
                    }}
                  >
                    <div
                      className="flex justify-center mb-3.5"
                      style={{ cursor: "pointer" }}
                    >
                      <button className="w-[200px] h-[44px] border border-[#333333]-700 rounded-[100px] text-sm text-[#333333] cursor-pointer hover:!cursor-pointer absolute">
                        Select Image to share
                      </button>
                      <input
                        type="file"
                        accept="image/*"
                        className="opacity-0 w-[100px]"
                      />
                    </div>
                    <h3>Please upload only png,jpg,or jpeg images</h3>
                  </div>
                </div>
                <div className="ssu2_modal1_input ssu2_modal3_selectBox">
                  <DatePicker
                    selected={testDate}
                    onChange={(date) => setTestDate(date)}
                    dateFormat="MM/dd/yyyy"
                    placeholderText="Expected start date"
                    className="ssu2_modal3_select"
                    style={{ maxWidth: "800px", Width: "100%" }}
                  />
                  <div className="input_left_post_icon">
                    <img width="18px" height="15px" alt="img" src={calendar} />
                  </div>
                </div>
                <div className="ssu2_modal1_input ssu2_modal3_selectBox">
                  <div className="input_left_icon">
                    <img alt="img" width="18px" height="15px" src={jobTitle} />
                  </div>
                  <input
                    className="ssu2_modal3_select"
                    placeholder="Status"
                    type="text"
                  />
                  <button
                    className="ssu2_modal1_button1 text-white bg-[#73C7A9] rounded-[28px] p-2 mt-3"
                    style={{ width: "100%" }}
                  >
                    SAVE
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </div> */}
      <div className="mt-6 px-[30px] py-2">
        <h1 className="t2_sp_work_title font-semibold">Contact Details</h1>
        <div className="t2_sp_work_container md:w-1/2 relative">
          <div className="grid grid-cols-2 w-full items-center gap-10">
            <div>
              <div className="mb-4">
                <h6 style={{ fontSize: 16 }}>Full Name</h6>
                <h5 className="mt-[10px] text-[20px]" title={userData.name}>
                  {userData.name}
                </h5>
              </div>
              <div>
                <h6 style={{ fontSize: 16 }}>DOB</h6>
                <h5 className="mt-[10px] text-[20px]" title={userData.jobTitle}>
                  {getDob()}
                </h5>
              </div>
            </div>
            <div>
              <div className="mb-4">
                <h6 style={{ fontSize: 16 }}>Email Address</h6>
                <h5 className="mt-[10px] text-[20px] text-ellipsis overflow-hidden">
                  {userData.email}
                </h5>
              </div>
              <div>
                <h6 style={{ fontSize: 16 }}>Phone Number</h6>
                <h5 className="mt-[10px] text-[20px]">{userData.phone}</h5>
              </div>
            </div>
            {(profile?.role === "staff" || profile?.role === "superAdmin") && (
              <div className="absolute right-4 top-4">
                <img
                  alt="icon.svg"
                  src={edit_note}
                  width="20px"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    const { day, month, year } = userData?.dob || {};
                    const prefilledDate =
                      day && month && year
                        ? new Date(year, month - 1, day)
                        : null;

                    setState({
                      ...state,
                      name: userData.name,
                      phone: userData.phone,
                    });

                    setDobDate(prefilledDate);
                    setContactModel(true);
                  }}
                />
              </div>
            )}
          </div>
        </div>
        <Modal
          isOpen={contactModel}
          onClose={() => setContactModel(false)}
          className="!w-[800px]"
        >
          <div className="p-4">
            <div className="font-semibold text-xl mb-4">
              Edit Contact Details
            </div>

            <div className="mb-4">
              <div className="text-base mb-2">Name</div>
              <input
                className="w-full border border-slate-300 rounded-lg px-4 py-2"
                placeholder="Full Name"
                type="text"
                value={state.name || ""}
                onChange={(e) => setState({ ...state, name: e.target.value })}
                onKeyDown={preventNumberInput}
              />
            </div>

            <div className="mb-4">
              <div className="text-base mb-2">DOB</div>
              <div className="ssu2_modal1_input ssu2_modal3_selectBox">
                <div className="input_left_icon">
                  <img width="18px" height="15px" alt="img" src={calendar} />
                </div>
                <DatePicker
                  selected={dobDate}
                  onChange={(date) => setDobDate(date)}
                  showYearDropdown
                  showMonthDropdown
                  dropdownMode="select"
                  dateFormat="MM/dd/yyyy"
                  placeholderText="Select Date of Birth"
                  className="ssu2_modal3_select"
                  maxDate={new Date()}
                />
              </div>
            </div>

            <div className="mb-4">
              <div className="text-base mb-2">Email Address</div>
              <input
                className="w-full border border-slate-300 rounded-lg px-4 py-2 bg-gray-100"
                placeholder="Email Address"
                type="text"
                value={userData.email || ""}
                readOnly
              />
            </div>

            <div className="mb-4">
              <div className="text-base mb-2">Phone Number</div>
              <input
                className="w-full border border-slate-300 rounded-lg px-4 py-2"
                type="number"
                value={state.phone || ""}
                placeholder="Phone Number"
                min="1"
                max="9999999999"
                onChange={setPhone}
                maxLength={10}
              />
              <ErrorState show={errors.phoneError} name={errors.phoneError} />
            </div>

            <div className="flex justify-end gap-3 mt-6">
              <button
                className="w-[120px] bg-white  border-1 text-[#73C7A9] rounded-[28px] border !border-[#73C7A9] p-2 hover:!bg-[#73C7A9] hover:text-white"
                onClick={() => setContactModel(false)}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 bg-[#73C7A9] rounded-[28px] text-white"
                onClick={async () => {
                  // if (!dobDate) {
                  //   showErrorToast("Please select a valid date of birth");
                  //   return;
                  // }
                  // if (errors.phoneError.length > 0) {
                  //   return;
                  // }
let  dob=null;
                  if (dobDate) {
                  dob = {
                      day: dobDate.getDate(),
                      month: dobDate.getMonth() + 1, // Months are zero-indexed
                      year: dobDate.getFullYear(),
                    };
                  }

                  await setUpdateAllData({
                    phone: state?.phone,
                    name: state?.name,
                    dob: dob, // formatted DOB object
                  });

                  setContactModel(false);
                }}
              >
                Update
              </button>
            </div>
          </div>
        </Modal>
      </div>
      <hr className="my-4" />

      <div className="grid md:grid-cols-2 gap-4 px-[30px] grid-cols-1">
        <div className="t2_sp_work_title w-full">
          <h1 className="font-semibold flex gap-2">
            Highest education level{" "}
            <img
              className="cursor-pointer"
              width="14px"
              height="14px"
              alt="img"
              src={iIcon}
              data-tooltip-id="education-tooltip"
            />
            <ReactTooltip
              id="education-tooltip"
              place="right"
              type="dark"
              className="custom-tooltip"
              content="The highest medical degree or qualification a staff has earned."
            />
          </h1>
          {!userData?.education?.college &&
            (profile?.role == "staff" || profile?.role == "superAdmin") && (
              <div
                className="ssu2_addItem mx-0 flex border !border-[#73C7A9] rounded-[25px] w-full h-auto py-[14px] px-[20px] text-[16px]"
                onClick={certopenModal}
              >
                + Add highest education
              </div>
            )}
          {userData?.education?.college && (
            <div
              className="mt-3 relative"
              style={{
                border: "1px solid #0000001A",
                boxShadow: " 0px 0px 4px rgba(0, 0, 0, 0.1)",
                borderRadius: "10px",
                padding: "20px 20px",
                width: "100%",
                minHeight: "202px",
              }}
            >
              <div className="flex items-center justify-between">
                <div className="my-3">
                  <h4 style={{ fontSize: "16px" }}>Degree</h4>
                  <h2 style={{ fontSize: "20px" }}>
                    {userData?.education?.degree}
                  </h2>
                </div>
                <div className="flex top-4 right-4 absolute gap-4">
                  {(profile?.role == "staff" ||
                    profile?.role == "superAdmin") && (
                    <img
                      className="cursor-pointer"
                      width="18px"
                      height="15px"
                      alt="img"
                      src={edit_note}
                      onClick={certopenModal}
                    />
                  )}
                  {(profile?.role == "staff" ||
                    profile?.role == "superAdmin") && (
                    <img
                      className="cursor-pointer"
                      width="18px"
                      height="15px"
                      alt="img"
                      onClick={() => {
                        deleteDetails({ name: "education" });
                      }}
                      src={trans}
                    />
                  )}
                </div>
              </div>
              <div className="flex items-center justify-between">
                <div className="my-3">
                  <h4 style={{ fontSize: "16px" }}>College/University</h4>
                  <h2 style={{ fontSize: "20px" }}>
                    {userData?.education?.college}
                  </h2>
                </div>
                <div className="my-3">
                  <h4 style={{ fontSize: "16px" }}>Received Date</h4>
                  <h2 style={{ fontSize: "20px" }}>
                    {userData?.education?.receivedOn == null ? (
                      <>
                        {new Date().toLocaleDateString("en-US", {
                          month: "2-digit",
                          day: "2-digit",
                          year: "numeric",
                        })}
                      </>
                    ) : (
                      <>
                        {moment(userData?.education?.receivedOn).format(
                          "MM-DD-YYYY"
                        )}
                      </>
                    )}
                  </h2>
                </div>
              </div>
            </div>
          )}
        </div>
        <Modal
          isOpen={certOpens}
          onClose={certcloseModal}
          className={"md:w-1/2 md:mt-0"}
        >
          <div
            className="d-flex flex-col items-center justify-center p-0"
            style={{ background: "#fff", borderRadius: "15px" }}
          >
            <div className="d-flex" style={{ width: "100%" }}>
              <div onClick={certcloseModal}>
                <svg
                  width="24"
                  height="20"
                  viewBox="0 0 30 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M30 10.927H6.23656L14.8599 2.30368L12.5562 0L0 12.5562L12.5562 25.1124L14.8599 22.8087L6.23656 14.1854H30V10.927Z"
                    fill="#333333"
                  />
                </svg>
              </div>
              <h1 className="mb-3" style={{ fontSize: "25px", margin: "auto" }}>
                {!userData?.education?.college ? "Add" : "Edit"} Degree
              </h1>
            </div>
            <h3>"What's your highest education level?"</h3>
            <div className="ssu2_modal1_input ssu2_modal3_selectBox">
              <div className="input_left_icon">
                <img alt="img" width="18px" height="15px" src={jobTitle} />
              </div>
              <input
                className="ssu2_modal3_select"
                placeholder="Degree"
                type="text"
                value={state?.education?.degree}
                onChange={(e) => {
                  setState((prev) => ({
                    ...prev,
                    education: {
                      ...prev.education,
                      degree: e.target.value,
                    },
                  }));
                }}
              />
            </div>
            <div className="ssu2_modal1_input ssu2_modal3_selectBox">
              <div className="input_left_icon">
                <img alt="img" width="18px" height="15px" src={jobTitle} />
              </div>
              <input
                className="ssu2_modal3_select"
                placeholder="College/University"
                type="text"
                value={state?.education?.college}
                onChange={(e) => {
                  setState((prev) => ({
                    ...prev,
                    education: {
                      ...prev.education,
                      college: e.target.value,
                    },
                  }));
                }}
              />
            </div>
            <div className="ssu2_modal1_input ssu2_modal3_selectBox">
              <DatePicker
                selected={
                  state?.education?.receivedOn
                    ? new Date(state?.education?.receivedOn)
                    : ""
                }
                dateFormat="MM/dd/yyyy"
                showYearDropdown
                showMonthDropdown
                dropdownMode="select"
                placeholderText="Select Date"
                className="ssu2_modal3_select"
                onChange={(date) => {
                  const formattedDate = date.toISOString();
                  setState((prev) => ({
                    ...prev,
                    education: {
                      ...prev.education,
                      receivedOn: formattedDate,
                    },
                  }));
                }}
                style={{ maxWidth: "800px", Width: "100%" }}
              />
              <div className="input_left_icon">
                <img width="18px" height="15px" alt="img" src={calendar} />
              </div>
              <h3>
                "Note: In case if you don't remember the exact date, select the
                first day of the month."
              </h3>
              <button
                className="ssu2_modal1_button1 text-white bg-[#73C7A9] rounded-[28px] p-2 mt-3"
                style={{ width: "100%" }}
                onClick={() => {
                  const { degree, college, receivedOn } =
                    state?.education || {};

                  if (!degree || !college || !receivedOn) {
                    showErrorToast("All fields are required");
                    return;
                  }

                  setUpdateAllData({ education: state.education });
                }}
              >
                SAVE
              </button>
            </div>
          </div>
        </Modal>
      </div>
      {/* <div>
        <ContactDetails/>
      </div> */}
      <div className="t2_sp_work_title px-[30px] mt-3">
        <h1 className="cardHeading flex gap-2">
          Certification{" "}
          <img
            className="cursor-pointer"
            width="14px"
            height="14px"
            alt="img"
            src={iIcon}
            data-tooltip-id="certification-tooltip"
          />
          <ReactTooltip
            id="certification-tooltip"
            place="right"
            type="dark"
            className="custom-tooltip"
            content="An official recognition of a professional's skills, knowledge, or training in a specific area."
          />
        </h1>

        {(profile?.role == "staff" || profile?.role == "superAdmin") && (
          <div
            className="ssu2_addItem mx-0 flex border !border-[#73C7A9] rounded-[25px] w-1/2 h-auto py-[14px] px-[20px] text-[16px]"
            onClick={highaddopenModal}
          >
            + Add another certification
          </div>
        )}
        <div className="grid md:grid-cols-2 grid-cols-1 gap-4">
          {userData?.certifications?.map((data, index) => {
            return (
              <div
                className="mt-3 relative"
                style={{
                  border: "1px solid #0000001A",
                  boxShadow: " 0px 0px 4px rgba(0, 0, 0, 0.1)",
                  borderRadius: "10px",
                  padding: "20px 20px",
                }}
              >
                <div className="flex items-center justify-between">
                  <div className="my-3">
                    <h4 style={{ fontSize: "16px" }}>Certification</h4>
                    <h2 style={{ fontSize: "20px" }}>{data.name}</h2>
                  </div>
                  <div className="flex top-4 right-4 absolute gap-4">
                    {(profile?.role == "staff" ||
                      profile?.role == "superAdmin") && (
                      <img
                        className="cursor-pointer"
                        width="18px"
                        height="15px"
                        alt="img"
                        src={edit_note}
                        onClick={() => {
                          setCertificationFormData(
                            state?.certifications?.[index]
                          );
                          setMappingIndexes((prev) => ({
                            ...prev,
                            certificationIndex: index,
                          }));
                          highopenModal();
                        }}
                      />
                    )}
                    {(profile?.role == "staff" ||
                      profile?.role == "superAdmin") && (
                      <img
                        className="cursor-pointer"
                        width="18px"
                        height="15px"
                        alt="img"
                        src={trans}
                        onClick={() => {
                          deleteDetails({ name: "certifications", index });
                        }}
                      />
                    )}
                  </div>
                </div>
                <div className="my-3">
                  <h4 style={{ fontSize: "16px" }}>Certifying Authority</h4>
                  <h2 style={{ fontSize: "20px" }}>
                    {data.certifyingAuthority}
                  </h2>
                </div>
                <div className="d-flex gap-5">
                  <div className="my-3">
                    <h4 style={{ fontSize: "16px" }}>Received Date</h4>
                    <h2 style={{ fontSize: "20px", marginTop: "10px" }}>
                      {data?.receivedOn == null ? (
                        <>
                          {new Date().toLocaleDateString("en-US", {
                            month: "2-digit",
                            day: "2-digit",
                            year: "numeric",
                          })}
                        </>
                      ) : (
                        <>{moment(data.receivedOn).format("MM-DD-YYYY")}</>
                      )}
                    </h2>
                  </div>
                  <div className="my-3">
                    <h4 style={{ fontSize: "16px" }}>Expiration Date</h4>
                    <h2 style={{ fontSize: "20px", marginTop: "10px" }}>
                      {data?.expirationDate == null ? (
                        <>
                          {new Date().toLocaleDateString("en-US", {
                            month: "2-digit",
                            day: "2-digit",
                            year: "numeric",
                          })}
                        </>
                      ) : (
                        <>{moment(data.expirationDate).format("MM-DD-YYYY")}</>
                      )}
                    </h2>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <Modal
        isOpen={highOpens}
        onClose={highcloseModal}
        className={"md:w-1/2 md:mt-0"}
      >
        <div
          className="d-flex flex-col items-center justify-center p-0"
          style={{ background: "#fff", borderRadius: "15px" }}
        >
          <div className="d-flex" style={{ width: "100%" }}>
            <div onClick={highcloseModal}>
              <svg
                width="24"
                height="20"
                viewBox="0 0 30 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M30 10.927H6.23656L14.8599 2.30368L12.5562 0L0 12.5562L12.5562 25.1124L14.8599 22.8087L6.23656 14.1854H30V10.927Z"
                  fill="#333333"
                />
              </svg>
            </div>
            <h1 className="mb-3" style={{ fontSize: "25px", margin: "auto" }}>
              Edit Certifications
            </h1>
          </div>
          <h3>What certifications do you have?</h3>
          <div className="ssu2_modal1_input ssu2_modal3_selectBox">
            <div className="input_left_icon">
              <img alt="img" width="18px" height="15px" src={jobTitle} />
            </div>
            <input
              className="ssu2_modal3_select"
              placeholder="Certification"
              type="text"
              onChange={(e) =>
                setCertificationFormData((prev) => ({
                  ...prev,
                  name: e.target.value,
                }))
              }
              value={certificationFormData?.name}
            />
          </div>
          <div className="ssu2_modal1_input ssu2_modal3_selectBox">
            <div className="input_left_icon">
              <img alt="img" width="18px" height="15px" src={jobTitle} />
            </div>
            <input
              className="ssu2_modal3_select"
              placeholder="Certifying Authority"
              type="text"
              onChange={(e) =>
                setCertificationFormData((prev) => ({
                  ...prev,
                  certifyingAuthority: e.target.value,
                }))
              }
              value={certificationFormData?.certifyingAuthority}
            />
          </div>
          <div className="ssu2_modal1_input ssu2_modal3_selectBox">
            <DatePicker
              selected={
                certificationFormData?.receivedOn
                  ? new Date(certificationFormData?.receivedOn)
                  : ""
              }
              onChange={(e) => {
                setCertificationFormData((prev) => ({
                  ...prev,
                  receivedOn: e,
                }));
              }}
              showYearDropdown
              showMonthDropdown
              dropdownMode="select"
              dateFormat="MM/dd/yyyy"
              placeholderText="Received Date"
              className="ssu2_modal3_select"
              style={{ maxWidth: "800px", Width: "100%" }}
            />
            <div className="input_left_icon">
              <img width="18px" height="15px" alt="img" src={calendar} />
            </div>
          </div>
          <div className="ssu2_modal1_input ssu2_modal3_selectBox">
            <DatePicker
              selected={
                certificationFormData?.expirationDate
                  ? new Date(certificationFormData?.expirationDate)
                  : ""
              }
              onChange={(e) => {
                setCertificationFormData((prev) => ({
                  ...prev,
                  expirationDate: e,
                }));
              }}
              showYearDropdown
              showMonthDropdown
              dropdownMode="select"
              dateFormat="MM/dd/yyyy"
              placeholderText="Expiration Date"
              className="ssu2_modal3_select"
              style={{ maxWidth: "800px", Width: "100%" }}
            />
            <div className="input_left_icon">
              <img width="18px" height="15px" alt="img" src={calendar} />
            </div>
            <button
              className="ssu2_modal1_button1 text-white bg-[#73C7A9] rounded-[28px] p-2 mt-3"
              style={{ width: "100%" }}
              onClick={() => updateCertificate()}
            >
              SAVE
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={highaddOpens}
        onClose={highaddcloseModal}
        className={"md:w-1/2 md:mt-0"}
      >
        <div
          className="d-flex flex-col items-center justify-center p-0"
          style={{ background: "#fff", borderRadius: "15px" }}
        >
          <div className="d-flex" style={{ width: "100%" }}>
            <div onClick={highaddcloseModal}>
              <svg
                width="24"
                height="20"
                viewBox="0 0 30 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M30 10.927H6.23656L14.8599 2.30368L12.5562 0L0 12.5562L12.5562 25.1124L14.8599 22.8087L6.23656 14.1854H30V10.927Z"
                  fill="#333333"
                />
              </svg>
            </div>
            <h1 className="mb-3" style={{ fontSize: "25px", margin: "auto" }}>
              Add Certifications
            </h1>
          </div>
          <h3>What certifications do you have?</h3>
          <div className="ssu2_modal1_input ssu2_modal3_selectBox">
            <div className="input_left_icon">
              <img alt="img" width="18px" height="15px" src={jobTitle} />
            </div>
            <input
              className="ssu2_modal3_select"
              placeholder="Certification"
              type="text"
              value={addCertificate?.name}
              onChange={(e) =>
                setAddCertificate((prev) => ({
                  ...prev,
                  name: e.target.value,
                }))
              }
            />
          </div>
          <div className="ssu2_modal1_input ssu2_modal3_selectBox">
            <div className="input_left_icon">
              <img alt="img" width="18px" height="15px" src={jobTitle} />
            </div>
            <input
              className="ssu2_modal3_select"
              placeholder="Certifying Authority"
              type="text"
              value={addCertificate?.certifyingAuthority}
              onChange={(e) =>
                setAddCertificate((prev) => ({
                  ...prev,
                  certifyingAuthority: e.target.value,
                }))
              }
            />
          </div>
          <div className="ssu2_modal1_input ssu2_modal3_selectBox">
            <DatePicker
              selected={
                addCertificate?.receivedOn
                  ? new Date(addCertificate?.receivedOn)
                  : ""
              }
              showYearDropdown
              showMonthDropdown
              dropdownMode="select"
              onChange={(e) =>
                setAddCertificate((prev) => ({
                  ...prev,
                  receivedOn: e,
                }))
              }
              dateFormat="MM/dd/yyyy"
              placeholderText="Received Date"
              className="ssu2_modal3_select"
              style={{ maxWidth: "800px", Width: "100%" }}
            />
            <div className="input_left_icon">
              <img width="18px" height="15px" alt="img" src={calendar} />
            </div>
          </div>
          <div className="ssu2_modal1_input ssu2_modal3_selectBox">
            <DatePicker
              selected={
                addCertificate?.expirationDate
                  ? new Date(addCertificate?.expirationDate)
                  : ""
              }
              showYearDropdown
              showMonthDropdown
              dropdownMode="select"
              onChange={(e) =>
                setAddCertificate((prev) => ({
                  ...prev,
                  expirationDate: e,
                }))
              }
              dateFormat="MM/dd/yyyy"
              placeholderText="Expiration Date"
              className="ssu2_modal3_select"
              style={{ maxWidth: "800px", Width: "100%" }}
            />
            <div className="input_left_icon">
              <img width="18px" height="15px" alt="img" src={calendar} />
            </div>
            <button
              className="ssu2_modal1_button1 text-white bg-[#73C7A9] rounded-[28px] p-2 mt-3"
              style={{ width: "100%" }}
              onClick={() => {
                const {
                  certifyingAuthority,
                  expirationDate,
                  name,
                  receivedOn,
                } = addCertificate || {};
                if (
                  !certifyingAuthority ||
                  !expirationDate ||
                  !name ||
                  !receivedOn
                ) {
                  showErrorToast("All fields are required");
                  return;
                }
                const updatedData = [...state?.certifications, addCertificate];
                setUpdateAllData({ certifications: updatedData });
              }}
            >
              SAVE
            </button>
          </div>
        </div>
      </Modal>

      <hr className="my-5" />
      <div className="px-[30px] mb-3 pb-6">
        <h1 className="flex cardHeading items-center">
          Location
          <span className="text-red-700">*</span>
          <img
            className="cursor-pointer ml-1"
            width="14px"
            height="14px"
            alt="img"
            src={iIcon}
            data-tooltip-id="location-tooltip"
          />
          <ReactTooltip
            id="location-tooltip"
            place="right"
            type="dark"
            className="custom-tooltip"
            content="The city or area where the professional is currently based or practicing"
          />
        </h1>

        <div className="ssu_selBox1" style={{}}>
          {userData?.currentLocation?.name &&
          userData?.currentLocation?.state &&
          userData?.currentLocation?.zipCode ? (
            <div
              className="relative max-w-[338px] flex items-center justify-between"
              style={{
                border: "1px solid #0000001A",
                boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.1)",
                borderRadius: "10px",
                padding: "20px 20px",
                minHeight: "70px",
                display: "inline-flex",
              }}
            >
              <p className="boxText">
                {userData?.currentLocation?.name},{" "}
                {userData?.currentLocation?.state} |{" "}
                {userData?.currentLocation?.zipCode}
              </p>

              {(profile?.role == "staff" || profile?.role == "superAdmin") && (
                <img
                  className="cursor-pointer"
                  width="18px"
                  height="15px"
                  alt="img"
                  src={edit_note}
                  onClick={() => {
                    setNewLocation({
                      city: userData?.currentLocation?.name,
                      state: userData?.currentLocation?.state,
                      zipCode: userData?.currentLocation?.zipCode,
                    });
                    setLocationEdit(true);
                    setLocationModalOpen(true);
                  }}
                />
              )}
            </div>
          ) : (
            // Show add button if no location
            (profile?.role == "staff" || profile?.role == "superAdmin") && (
              <div
                className="ssu2_addItem mx-0 flex border !border-[#73C7A9] rounded-[25px] w-1/2 h-auto py-[14px] px-[20px] text-[16px]"
                onClick={() => setLocationModalOpen(true)}
              >
                + Add Location
              </div>
            )
          )}
          <Modal
            isOpen={locationModalOpen}
            onClose={() => setLocationModalOpen(false)}
            className={"md:w-1/2 md:mt-0"}
          >
            <div
              className="d-flex flex-col items-center justify-center p-0"
              style={{ background: "#fff", borderRadius: "15px" }}
            >
              <div className="d-flex" style={{ width: "100%" }}>
                <div
                  onClick={() => {
                    setLocationEdit(false);
                    setLocationModalOpen(false);
                  }}
                >
                  <svg
                    width="24"
                    height="20"
                    viewBox="0 0 30 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M30 10.927H6.23656L14.8599 2.30368L12.5562 0L0 12.5562L12.5562 25.1124L14.8599 22.8087L6.23656 14.1854H30V10.927Z"
                      fill="#333333"
                    />
                  </svg>
                </div>
                <h1
                  className="mb-3"
                  style={{ fontSize: "25px", margin: "auto" }}
                >
                  {isLocationEdit ? "Edit Location" : "Add Location"}
                </h1>
              </div>

              <div className="ssu2_modal1_input ssu2_modal3_selectBox">
                <div className="input_left_icon">
                  <img alt="img" width="18px" height="15px" src={jobTitle} />
                </div>
                <input
                  className="ssu2_modal3_select "
                  placeholder="ZIP Code"
                  type="text"
                  value={newLocation.zipCode}
                  onChange={handleZipChange}
                  maxLength={5}
                />
                {errors.zipError.length > 0 && (
                  <div className="mt-2">
                    <ErrorState
                      className="mt-2"
                      show={errors.zipError}
                      name="Valid zip code is required."
                    />
                  </div>
                )}
              </div>

              <div className="ssu2_modal1_input ssu2_modal3_selectBox">
                <div className="input_left_icon">
                  <img alt="img" width="18px" height="15px" src={place} />
                </div>
                <input
                  className="ssu2_modal3_select"
                  placeholder="City"
                  type="text"
                  value={newLocation.city}
                  readOnly
                />
              </div>

              <div className="ssu2_modal1_input ssu2_modal3_selectBox">
                <div className="input_left_icon">
                  <img alt="img" width="18px" height="15px" src={place} />
                </div>
                <input
                  className="ssu2_modal3_select"
                  placeholder="State"
                  type="text"
                  value={newLocation.state}
                  readOnly
                />
              </div>

              <button
                className="ssu2_modal1_button1 text-white bg-[#73C7A9] rounded-[28px] p-2 mt-3"
                style={{ width: "100%" }}
                onClick={async () => {
                  if (
                    !newLocation.zipCode ||
                    !newLocation.city ||
                    !newLocation.state ||
                    errors.zipError
                  ) {
                    showErrorToast("Please enter a valid ZIP Code.");
                    return;
                  }

                  await setUpdateAllData({
                    currentLocation: {
                      name: newLocation.city,
                      state: newLocation.state,
                      zipCode: newLocation.zipCode,
                    },
                  });

                  setLocationModalOpen(false);
                }}
              >
                SAVE
              </button>
            </div>
          </Modal>

          {/* <div className="flex flex-wrap gap-2">
            {_exps.map((item) => (
              <ToggleExpItem
                key={item}
                exp={item}
                toggleExp={toggleExp}
                display="block"
                clicked={selectedExp === item}
              />
            ))}
            <div className="ssu2_otherItem w-[170px] h-auto">
              <ToggleExpItem
                exp="Other"
                toggleExp={toggleExp}
                clicked={selectedExp === "Other"}
                display={
                  !_exps.includes(state?.medicalSettings) || showOtherExp
                    ? "block"
                    : "none"
                }
                width="100%"
              />
            </div>
          </div>
          {(!_exps.includes(state?.medicalSettings) || showOtherExp) && (
            <div className="flex gap-4 ssu2_modal1_input ssu2_modal3_selectBox flex-row">
              <input
                className="ssu2_modal1_input ssu2_modal3_select d-flex pl-5"
                placeholder="Please specify"
                type="text"
                value={otherExpText}
                onChange={setOtherExp}
                onKeyUp={(e) => {
                  if (e.key === "Enter") continueToNext();
                }}
              />
              <Button onClick={continueToNext} className="rounded-full">
                Save
              </Button>
            </div>
          )} */}
        </div>
      </div>
    </div>
  );
};

export default JobType;
